var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as globalImportUrl from 'url';
import globalAxios from 'axios';
import { BASE_PATH, BaseAPI, RequiredError } from './base';
export var AbstractBuildingConstructionEnum;
(function (AbstractBuildingConstructionEnum) {
    AbstractBuildingConstructionEnum["SOLID"] = "SOLID";
    AbstractBuildingConstructionEnum["CONCRETE_SLAB"] = "CONCRETE_SLAB";
    AbstractBuildingConstructionEnum["WOOD_STAND"] = "WOOD_STAND";
    AbstractBuildingConstructionEnum["WOOD"] = "WOOD";
    AbstractBuildingConstructionEnum["LOG_BUILDING"] = "LOG_BUILDING";
    AbstractBuildingConstructionEnum["TIMBER_FRAMING"] = "TIMBER_FRAMING";
    AbstractBuildingConstructionEnum["COB"] = "COB";
    AbstractBuildingConstructionEnum["OTHER"] = "OTHER";
})(AbstractBuildingConstructionEnum || (AbstractBuildingConstructionEnum = {}));
export var AbstractBuildingCalculatedUsageEnum;
(function (AbstractBuildingCalculatedUsageEnum) {
    AbstractBuildingCalculatedUsageEnum["SELF"] = "SELF";
    AbstractBuildingCalculatedUsageEnum["RENT"] = "RENT";
    AbstractBuildingCalculatedUsageEnum["PARTIALLY_RENT"] = "PARTIALLY_RENT";
})(AbstractBuildingCalculatedUsageEnum || (AbstractBuildingCalculatedUsageEnum = {}));
export var AbstractBuildingValuationOfFittingsEnum;
(function (AbstractBuildingValuationOfFittingsEnum) {
    AbstractBuildingValuationOfFittingsEnum["SIMPLE"] = "SIMPLE";
    AbstractBuildingValuationOfFittingsEnum["GOOD"] = "GOOD";
    AbstractBuildingValuationOfFittingsEnum["VERY_GOOD"] = "VERY_GOOD";
})(AbstractBuildingValuationOfFittingsEnum || (AbstractBuildingValuationOfFittingsEnum = {}));
export var AbstractBuildingEnergyEfficiencyClassificationEnum;
(function (AbstractBuildingEnergyEfficiencyClassificationEnum) {
    AbstractBuildingEnergyEfficiencyClassificationEnum["APLUS"] = "APLUS";
    AbstractBuildingEnergyEfficiencyClassificationEnum["A"] = "A";
    AbstractBuildingEnergyEfficiencyClassificationEnum["B"] = "B";
    AbstractBuildingEnergyEfficiencyClassificationEnum["C"] = "C";
    AbstractBuildingEnergyEfficiencyClassificationEnum["D"] = "D";
    AbstractBuildingEnergyEfficiencyClassificationEnum["E"] = "E";
    AbstractBuildingEnergyEfficiencyClassificationEnum["F"] = "F";
    AbstractBuildingEnergyEfficiencyClassificationEnum["G"] = "G";
    AbstractBuildingEnergyEfficiencyClassificationEnum["H"] = "H";
})(AbstractBuildingEnergyEfficiencyClassificationEnum || (AbstractBuildingEnergyEfficiencyClassificationEnum = {}));
export var AbstractBuildingEnergyEfficiencyStandardEnum;
(function (AbstractBuildingEnergyEfficiencyStandardEnum) {
    AbstractBuildingEnergyEfficiencyStandardEnum["KFW_EFFIZIENZHAUS_40"] = "KFW_EFFIZIENZHAUS_40";
    AbstractBuildingEnergyEfficiencyStandardEnum["KFW_EFFIZIENZHAUS_40PLUS"] = "KFW_EFFIZIENZHAUS_40PLUS";
    AbstractBuildingEnergyEfficiencyStandardEnum["KFW_EFFIZIENZHAUS_40_MIT_NACHHALTIGKEIT"] = "KFW_EFFIZIENZHAUS_40_MIT_NACHHALTIGKEIT";
    AbstractBuildingEnergyEfficiencyStandardEnum["KFW_EFFIZIENZHAUS_55"] = "KFW_EFFIZIENZHAUS_55";
    AbstractBuildingEnergyEfficiencyStandardEnum["KFW_EFFIZIENZHAUS_55PLUS"] = "KFW_EFFIZIENZHAUS_55PLUS";
    AbstractBuildingEnergyEfficiencyStandardEnum["KFW_EFFIZIENZHAUS_55_MIT_NACHHALTIGKEIT"] = "KFW_EFFIZIENZHAUS_55_MIT_NACHHALTIGKEIT";
    AbstractBuildingEnergyEfficiencyStandardEnum["SONSTIGES"] = "SONSTIGES";
})(AbstractBuildingEnergyEfficiencyStandardEnum || (AbstractBuildingEnergyEfficiencyStandardEnum = {}));
export var AbstractModernisationTypeEnum;
(function (AbstractModernisationTypeEnum) {
    AbstractModernisationTypeEnum["INSULATION"] = "INSULATION";
    AbstractModernisationTypeEnum["ROOF"] = "ROOF";
    AbstractModernisationTypeEnum["FACADE"] = "FACADE";
    AbstractModernisationTypeEnum["WINDOWS_OR_DOORS"] = "WINDOWS_OR_DOORS";
    AbstractModernisationTypeEnum["HEAT_PROTECTION"] = "HEAT_PROTECTION";
    AbstractModernisationTypeEnum["VENTILATION_SYSTEM"] = "VENTILATION_SYSTEM";
    AbstractModernisationTypeEnum["ELECTRICS"] = "ELECTRICS";
    AbstractModernisationTypeEnum["DIGITAL_ENERGY_OPTIMISATION"] = "DIGITAL_ENERGY_OPTIMISATION";
    AbstractModernisationTypeEnum["HEATING"] = "HEATING";
    AbstractModernisationTypeEnum["BATHROOMS"] = "BATHROOMS";
    AbstractModernisationTypeEnum["POWER_WATER_HEATINGPIPES"] = "POWER_WATER_HEATINGPIPES";
    AbstractModernisationTypeEnum["FLOOR_WALL_STAIRCASES"] = "FLOOR_WALL_STAIRCASES";
    AbstractModernisationTypeEnum["STRUCTURE"] = "STRUCTURE";
    AbstractModernisationTypeEnum["OTHER"] = "OTHER";
    AbstractModernisationTypeEnum["TOTAL"] = "TOTAL";
})(AbstractModernisationTypeEnum || (AbstractModernisationTypeEnum = {}));
export var AdditionalLoanUsageEnum;
(function (AdditionalLoanUsageEnum) {
    AdditionalLoanUsageEnum["WORKING_CAPITAL_LOAN"] = "WORKING_CAPITAL_LOAN";
    AdditionalLoanUsageEnum["REPAYMENT_OTHER_LOANS"] = "REPAYMENT_OTHER_LOANS";
    AdditionalLoanUsageEnum["PREPAYMENT_PENALTY"] = "PREPAYMENT_PENALTY";
    AdditionalLoanUsageEnum["RENOVATE"] = "RENOVATE";
    AdditionalLoanUsageEnum["OTHER"] = "OTHER";
})(AdditionalLoanUsageEnum || (AdditionalLoanUsageEnum = {}));
export var AdditionalSalesInfoSalesTypeEnum;
(function (AdditionalSalesInfoSalesTypeEnum) {
    AdditionalSalesInfoSalesTypeEnum["B2C_SALES"] = "B2C_SALES";
    AdditionalSalesInfoSalesTypeEnum["B2B_SALES"] = "B2B_SALES";
})(AdditionalSalesInfoSalesTypeEnum || (AdditionalSalesInfoSalesTypeEnum = {}));
export var AddressInhabitantsEnum;
(function (AddressInhabitantsEnum) {
    AddressInhabitantsEnum["UP_TO_1000"] = "UP_TO_1000";
    AddressInhabitantsEnum["UP_TO_10000"] = "UP_TO_10000";
    AddressInhabitantsEnum["UP_TO_50000"] = "UP_TO_50000";
    AddressInhabitantsEnum["UP_TO_100000"] = "UP_TO_100000";
    AddressInhabitantsEnum["UP_TO_200000"] = "UP_TO_200000";
    AddressInhabitantsEnum["UP_TO_500000"] = "UP_TO_500000";
    AddressInhabitantsEnum["UP_TO_1000000"] = "UP_TO_1000000";
    AddressInhabitantsEnum["MORE_THEN_1000000"] = "MORE_THEN_1000000";
})(AddressInhabitantsEnum || (AddressInhabitantsEnum = {}));
export var AddressEnvironmentEnum;
(function (AddressEnvironmentEnum) {
    AddressEnvironmentEnum["RESIDENTIAL_AREA"] = "RESIDENTIAL_AREA";
    AddressEnvironmentEnum["BUSINESS_AREA"] = "BUSINESS_AREA";
    AddressEnvironmentEnum["MIXED_AREA"] = "MIXED_AREA";
    AddressEnvironmentEnum["OUTSIDE_AREA"] = "OUTSIDE_AREA";
})(AddressEnvironmentEnum || (AddressEnvironmentEnum = {}));
export var ApartmentFloorEnum;
(function (ApartmentFloorEnum) {
    ApartmentFloorEnum["BASEMENT"] = "BASEMENT";
    ApartmentFloorEnum["GROUND_FLOOR"] = "GROUND_FLOOR";
    ApartmentFloorEnum["UPPER_FLOOR_1"] = "UPPER_FLOOR_1";
    ApartmentFloorEnum["UPPER_FLOOR_2"] = "UPPER_FLOOR_2";
    ApartmentFloorEnum["UPPER_FLOOR_BETWEEN_3_AND_5"] = "UPPER_FLOOR_BETWEEN_3_AND_5";
    ApartmentFloorEnum["UPPER_FLOOR_6_AND_ABOVE"] = "UPPER_FLOOR_6_AND_ABOVE";
})(ApartmentFloorEnum || (ApartmentFloorEnum = {}));
export var AssetTypeEnum;
(function (AssetTypeEnum) {
    AssetTypeEnum["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    AssetTypeEnum["BUILDINGLOAN"] = "BUILDINGLOAN";
    AssetTypeEnum["CRYPTO_CURRENCY"] = "CRYPTO_CURRENCY";
    AssetTypeEnum["LIFEINSURANCES"] = "LIFEINSURANCES";
    AssetTypeEnum["SECURITIES_PORTFOLIO"] = "SECURITIES_PORTFOLIO";
    AssetTypeEnum["OTHER"] = "OTHER";
    AssetTypeEnum["EQUITY_CASH"] = "EQUITY_CASH";
})(AssetTypeEnum || (AssetTypeEnum = {}));
export var BridgingLoanReason;
(function (BridgingLoanReason) {
    BridgingLoanReason["OPEN_PROPERTY_SALE"] = "OPEN_PROPERTY_SALE";
    BridgingLoanReason["CLOSED_PROPERTY_SALE"] = "CLOSED_PROPERTY_SALE";
    BridgingLoanReason["UNAVAILABLE"] = "UNAVAILABLE";
    BridgingLoanReason["PUBLIC_PRE_FINANCE"] = "PUBLIC_PRE_FINANCE";
})(BridgingLoanReason || (BridgingLoanReason = {}));
export var BuildingLeaseBuildingLessorEnum;
(function (BuildingLeaseBuildingLessorEnum) {
    BuildingLeaseBuildingLessorEnum["CHURCH"] = "CHURCH";
    BuildingLeaseBuildingLessorEnum["CITY"] = "CITY";
    BuildingLeaseBuildingLessorEnum["PRIVATE_PERSON"] = "PRIVATE_PERSON";
    BuildingLeaseBuildingLessorEnum["COMPANY"] = "COMPANY";
    BuildingLeaseBuildingLessorEnum["OTHER"] = "OTHER";
})(BuildingLeaseBuildingLessorEnum || (BuildingLeaseBuildingLessorEnum = {}));
export var ContactTypeEnum;
(function (ContactTypeEnum) {
    ContactTypeEnum["PHONE"] = "PHONE";
    ContactTypeEnum["LANDLINE"] = "LANDLINE";
    ContactTypeEnum["MOBILE"] = "MOBILE";
    ContactTypeEnum["MOBILE_WORK"] = "MOBILE_WORK";
    ContactTypeEnum["EMAIL"] = "EMAIL";
})(ContactTypeEnum || (ContactTypeEnum = {}));
export var CopyReason;
(function (CopyReason) {
    CopyReason["FOLLOW_UP_FINANCING"] = "FOLLOW_UP_FINANCING";
    CopyReason["RAISE_CAPITAL"] = "RAISE_CAPITAL";
    CopyReason["REFINANCE"] = "REFINANCE";
    CopyReason["RENOVATE"] = "RENOVATE";
    CopyReason["PARALLEL_MORTGAGE_INTENT"] = "PARALLEL_MORTGAGE_INTENT";
    CopyReason["NEW_MORTGAGE_INTENT"] = "NEW_MORTGAGE_INTENT";
    CopyReason["DUPLICATION"] = "DUPLICATION";
})(CopyReason || (CopyReason = {}));
export var CountryCodeValueEnum;
(function (CountryCodeValueEnum) {
    CountryCodeValueEnum["AD"] = "AD";
    CountryCodeValueEnum["AE"] = "AE";
    CountryCodeValueEnum["AF"] = "AF";
    CountryCodeValueEnum["AG"] = "AG";
    CountryCodeValueEnum["AL"] = "AL";
    CountryCodeValueEnum["AM"] = "AM";
    CountryCodeValueEnum["AO"] = "AO";
    CountryCodeValueEnum["AR"] = "AR";
    CountryCodeValueEnum["AT"] = "AT";
    CountryCodeValueEnum["AU"] = "AU";
    CountryCodeValueEnum["AW"] = "AW";
    CountryCodeValueEnum["AZ"] = "AZ";
    CountryCodeValueEnum["BA"] = "BA";
    CountryCodeValueEnum["BB"] = "BB";
    CountryCodeValueEnum["BD"] = "BD";
    CountryCodeValueEnum["BE"] = "BE";
    CountryCodeValueEnum["BF"] = "BF";
    CountryCodeValueEnum["BG"] = "BG";
    CountryCodeValueEnum["BH"] = "BH";
    CountryCodeValueEnum["BI"] = "BI";
    CountryCodeValueEnum["BJ"] = "BJ";
    CountryCodeValueEnum["BM"] = "BM";
    CountryCodeValueEnum["BN"] = "BN";
    CountryCodeValueEnum["BO"] = "BO";
    CountryCodeValueEnum["BR"] = "BR";
    CountryCodeValueEnum["BS"] = "BS";
    CountryCodeValueEnum["BT"] = "BT";
    CountryCodeValueEnum["BW"] = "BW";
    CountryCodeValueEnum["BY"] = "BY";
    CountryCodeValueEnum["BZ"] = "BZ";
    CountryCodeValueEnum["CA"] = "CA";
    CountryCodeValueEnum["CD"] = "CD";
    CountryCodeValueEnum["CF"] = "CF";
    CountryCodeValueEnum["CG"] = "CG";
    CountryCodeValueEnum["CH"] = "CH";
    CountryCodeValueEnum["CI"] = "CI";
    CountryCodeValueEnum["CL"] = "CL";
    CountryCodeValueEnum["CM"] = "CM";
    CountryCodeValueEnum["CN"] = "CN";
    CountryCodeValueEnum["CO"] = "CO";
    CountryCodeValueEnum["CR"] = "CR";
    CountryCodeValueEnum["CU"] = "CU";
    CountryCodeValueEnum["CV"] = "CV";
    CountryCodeValueEnum["CY"] = "CY";
    CountryCodeValueEnum["CZ"] = "CZ";
    CountryCodeValueEnum["DE"] = "DE";
    CountryCodeValueEnum["DJ"] = "DJ";
    CountryCodeValueEnum["DK"] = "DK";
    CountryCodeValueEnum["DM"] = "DM";
    CountryCodeValueEnum["DO"] = "DO";
    CountryCodeValueEnum["DZ"] = "DZ";
    CountryCodeValueEnum["EC"] = "EC";
    CountryCodeValueEnum["EE"] = "EE";
    CountryCodeValueEnum["EG"] = "EG";
    CountryCodeValueEnum["ER"] = "ER";
    CountryCodeValueEnum["ES"] = "ES";
    CountryCodeValueEnum["ET"] = "ET";
    CountryCodeValueEnum["FI"] = "FI";
    CountryCodeValueEnum["FJ"] = "FJ";
    CountryCodeValueEnum["FM"] = "FM";
    CountryCodeValueEnum["FR"] = "FR";
    CountryCodeValueEnum["GA"] = "GA";
    CountryCodeValueEnum["GB"] = "GB";
    CountryCodeValueEnum["GD"] = "GD";
    CountryCodeValueEnum["GE"] = "GE";
    CountryCodeValueEnum["GF"] = "GF";
    CountryCodeValueEnum["GH"] = "GH";
    CountryCodeValueEnum["GM"] = "GM";
    CountryCodeValueEnum["GN"] = "GN";
    CountryCodeValueEnum["GQ"] = "GQ";
    CountryCodeValueEnum["GR"] = "GR";
    CountryCodeValueEnum["GT"] = "GT";
    CountryCodeValueEnum["GW"] = "GW";
    CountryCodeValueEnum["GY"] = "GY";
    CountryCodeValueEnum["HN"] = "HN";
    CountryCodeValueEnum["HR"] = "HR";
    CountryCodeValueEnum["HT"] = "HT";
    CountryCodeValueEnum["HU"] = "HU";
    CountryCodeValueEnum["ID"] = "ID";
    CountryCodeValueEnum["IE"] = "IE";
    CountryCodeValueEnum["IL"] = "IL";
    CountryCodeValueEnum["IN"] = "IN";
    CountryCodeValueEnum["IQ"] = "IQ";
    CountryCodeValueEnum["IR"] = "IR";
    CountryCodeValueEnum["IS"] = "IS";
    CountryCodeValueEnum["IT"] = "IT";
    CountryCodeValueEnum["JM"] = "JM";
    CountryCodeValueEnum["JO"] = "JO";
    CountryCodeValueEnum["JP"] = "JP";
    CountryCodeValueEnum["KE"] = "KE";
    CountryCodeValueEnum["KG"] = "KG";
    CountryCodeValueEnum["KH"] = "KH";
    CountryCodeValueEnum["KI"] = "KI";
    CountryCodeValueEnum["KM"] = "KM";
    CountryCodeValueEnum["KN"] = "KN";
    CountryCodeValueEnum["KP"] = "KP";
    CountryCodeValueEnum["KR"] = "KR";
    CountryCodeValueEnum["KW"] = "KW";
    CountryCodeValueEnum["KY"] = "KY";
    CountryCodeValueEnum["KZ"] = "KZ";
    CountryCodeValueEnum["LA"] = "LA";
    CountryCodeValueEnum["LB"] = "LB";
    CountryCodeValueEnum["LC"] = "LC";
    CountryCodeValueEnum["LI"] = "LI";
    CountryCodeValueEnum["LK"] = "LK";
    CountryCodeValueEnum["LR"] = "LR";
    CountryCodeValueEnum["LS"] = "LS";
    CountryCodeValueEnum["LT"] = "LT";
    CountryCodeValueEnum["LU"] = "LU";
    CountryCodeValueEnum["LV"] = "LV";
    CountryCodeValueEnum["LY"] = "LY";
    CountryCodeValueEnum["MA"] = "MA";
    CountryCodeValueEnum["MC"] = "MC";
    CountryCodeValueEnum["MD"] = "MD";
    CountryCodeValueEnum["ME"] = "ME";
    CountryCodeValueEnum["MG"] = "MG";
    CountryCodeValueEnum["MH"] = "MH";
    CountryCodeValueEnum["MK"] = "MK";
    CountryCodeValueEnum["ML"] = "ML";
    CountryCodeValueEnum["MM"] = "MM";
    CountryCodeValueEnum["MN"] = "MN";
    CountryCodeValueEnum["MR"] = "MR";
    CountryCodeValueEnum["MT"] = "MT";
    CountryCodeValueEnum["MU"] = "MU";
    CountryCodeValueEnum["MV"] = "MV";
    CountryCodeValueEnum["MW"] = "MW";
    CountryCodeValueEnum["MX"] = "MX";
    CountryCodeValueEnum["MY"] = "MY";
    CountryCodeValueEnum["MZ"] = "MZ";
    CountryCodeValueEnum["NA"] = "NA";
    CountryCodeValueEnum["NE"] = "NE";
    CountryCodeValueEnum["NG"] = "NG";
    CountryCodeValueEnum["NI"] = "NI";
    CountryCodeValueEnum["NL"] = "NL";
    CountryCodeValueEnum["NO"] = "NO";
    CountryCodeValueEnum["NP"] = "NP";
    CountryCodeValueEnum["NR"] = "NR";
    CountryCodeValueEnum["NZ"] = "NZ";
    CountryCodeValueEnum["OM"] = "OM";
    CountryCodeValueEnum["PA"] = "PA";
    CountryCodeValueEnum["PE"] = "PE";
    CountryCodeValueEnum["PG"] = "PG";
    CountryCodeValueEnum["PH"] = "PH";
    CountryCodeValueEnum["PK"] = "PK";
    CountryCodeValueEnum["PL"] = "PL";
    CountryCodeValueEnum["PS"] = "PS";
    CountryCodeValueEnum["PT"] = "PT";
    CountryCodeValueEnum["PW"] = "PW";
    CountryCodeValueEnum["PY"] = "PY";
    CountryCodeValueEnum["QA"] = "QA";
    CountryCodeValueEnum["RO"] = "RO";
    CountryCodeValueEnum["RS"] = "RS";
    CountryCodeValueEnum["RU"] = "RU";
    CountryCodeValueEnum["RW"] = "RW";
    CountryCodeValueEnum["SA"] = "SA";
    CountryCodeValueEnum["SB"] = "SB";
    CountryCodeValueEnum["SC"] = "SC";
    CountryCodeValueEnum["SD"] = "SD";
    CountryCodeValueEnum["SE"] = "SE";
    CountryCodeValueEnum["SG"] = "SG";
    CountryCodeValueEnum["SI"] = "SI";
    CountryCodeValueEnum["SK"] = "SK";
    CountryCodeValueEnum["SL"] = "SL";
    CountryCodeValueEnum["SM"] = "SM";
    CountryCodeValueEnum["SN"] = "SN";
    CountryCodeValueEnum["SO"] = "SO";
    CountryCodeValueEnum["SR"] = "SR";
    CountryCodeValueEnum["ST"] = "ST";
    CountryCodeValueEnum["SV"] = "SV";
    CountryCodeValueEnum["SY"] = "SY";
    CountryCodeValueEnum["SZ"] = "SZ";
    CountryCodeValueEnum["TD"] = "TD";
    CountryCodeValueEnum["TG"] = "TG";
    CountryCodeValueEnum["TH"] = "TH";
    CountryCodeValueEnum["TJ"] = "TJ";
    CountryCodeValueEnum["TL"] = "TL";
    CountryCodeValueEnum["TM"] = "TM";
    CountryCodeValueEnum["TN"] = "TN";
    CountryCodeValueEnum["TO"] = "TO";
    CountryCodeValueEnum["TR"] = "TR";
    CountryCodeValueEnum["TT"] = "TT";
    CountryCodeValueEnum["TV"] = "TV";
    CountryCodeValueEnum["TW"] = "TW";
    CountryCodeValueEnum["TZ"] = "TZ";
    CountryCodeValueEnum["UA"] = "UA";
    CountryCodeValueEnum["UG"] = "UG";
    CountryCodeValueEnum["US"] = "US";
    CountryCodeValueEnum["UY"] = "UY";
    CountryCodeValueEnum["UZ"] = "UZ";
    CountryCodeValueEnum["VA"] = "VA";
    CountryCodeValueEnum["VC"] = "VC";
    CountryCodeValueEnum["VE"] = "VE";
    CountryCodeValueEnum["VN"] = "VN";
    CountryCodeValueEnum["VU"] = "VU";
    CountryCodeValueEnum["WS"] = "WS";
    CountryCodeValueEnum["XK"] = "XK";
    CountryCodeValueEnum["XX"] = "XX";
    CountryCodeValueEnum["YE"] = "YE";
    CountryCodeValueEnum["ZA"] = "ZA";
    CountryCodeValueEnum["ZM"] = "ZM";
    CountryCodeValueEnum["ZW"] = "ZW";
})(CountryCodeValueEnum || (CountryCodeValueEnum = {}));
export var CountryType;
(function (CountryType) {
    CountryType["XK"] = "XK";
    CountryType["PS"] = "PS";
    CountryType["PT"] = "PT";
    CountryType["PW"] = "PW";
    CountryType["PY"] = "PY";
    CountryType["QA"] = "QA";
    CountryType["AD"] = "AD";
    CountryType["AE"] = "AE";
    CountryType["AF"] = "AF";
    CountryType["AG"] = "AG";
    CountryType["AL"] = "AL";
    CountryType["AM"] = "AM";
    CountryType["AO"] = "AO";
    CountryType["AR"] = "AR";
    CountryType["AT"] = "AT";
    CountryType["AU"] = "AU";
    CountryType["AW"] = "AW";
    CountryType["AZ"] = "AZ";
    CountryType["RO"] = "RO";
    CountryType["BA"] = "BA";
    CountryType["BB"] = "BB";
    CountryType["RS"] = "RS";
    CountryType["BD"] = "BD";
    CountryType["BE"] = "BE";
    CountryType["RU"] = "RU";
    CountryType["BF"] = "BF";
    CountryType["BG"] = "BG";
    CountryType["RW"] = "RW";
    CountryType["BH"] = "BH";
    CountryType["BI"] = "BI";
    CountryType["BJ"] = "BJ";
    CountryType["BM"] = "BM";
    CountryType["BN"] = "BN";
    CountryType["BO"] = "BO";
    CountryType["SA"] = "SA";
    CountryType["SB"] = "SB";
    CountryType["BR"] = "BR";
    CountryType["SC"] = "SC";
    CountryType["BS"] = "BS";
    CountryType["SD"] = "SD";
    CountryType["BT"] = "BT";
    CountryType["SE"] = "SE";
    CountryType["SG"] = "SG";
    CountryType["BW"] = "BW";
    CountryType["SI"] = "SI";
    CountryType["BY"] = "BY";
    CountryType["BZ"] = "BZ";
    CountryType["SK"] = "SK";
    CountryType["SL"] = "SL";
    CountryType["SM"] = "SM";
    CountryType["SN"] = "SN";
    CountryType["SO"] = "SO";
    CountryType["CA"] = "CA";
    CountryType["SR"] = "SR";
    CountryType["CD"] = "CD";
    CountryType["ST"] = "ST";
    CountryType["SV"] = "SV";
    CountryType["CF"] = "CF";
    CountryType["CG"] = "CG";
    CountryType["CH"] = "CH";
    CountryType["CI"] = "CI";
    CountryType["SY"] = "SY";
    CountryType["SZ"] = "SZ";
    CountryType["CL"] = "CL";
    CountryType["CM"] = "CM";
    CountryType["CN"] = "CN";
    CountryType["CO"] = "CO";
    CountryType["CR"] = "CR";
    CountryType["TD"] = "TD";
    CountryType["CU"] = "CU";
    CountryType["CV"] = "CV";
    CountryType["TG"] = "TG";
    CountryType["TH"] = "TH";
    CountryType["CY"] = "CY";
    CountryType["CZ"] = "CZ";
    CountryType["TL"] = "TL";
    CountryType["TM"] = "TM";
    CountryType["TN"] = "TN";
    CountryType["TO"] = "TO";
    CountryType["TR"] = "TR";
    CountryType["TT"] = "TT";
    CountryType["DE"] = "DE";
    CountryType["TV"] = "TV";
    CountryType["TW"] = "TW";
    CountryType["DJ"] = "DJ";
    CountryType["TZ"] = "TZ";
    CountryType["DK"] = "DK";
    CountryType["DM"] = "DM";
    CountryType["DO"] = "DO";
    CountryType["UA"] = "UA";
    CountryType["UG"] = "UG";
    CountryType["TJ"] = "TJ";
    CountryType["DZ"] = "DZ";
    CountryType["EC"] = "EC";
    CountryType["US"] = "US";
    CountryType["EE"] = "EE";
    CountryType["EG"] = "EG";
    CountryType["UY"] = "UY";
    CountryType["UZ"] = "UZ";
    CountryType["VA"] = "VA";
    CountryType["ER"] = "ER";
    CountryType["VC"] = "VC";
    CountryType["ES"] = "ES";
    CountryType["ET"] = "ET";
    CountryType["VE"] = "VE";
    CountryType["VN"] = "VN";
    CountryType["VU"] = "VU";
    CountryType["FI"] = "FI";
    CountryType["FJ"] = "FJ";
    CountryType["FM"] = "FM";
    CountryType["FR"] = "FR";
    CountryType["GA"] = "GA";
    CountryType["GB"] = "GB";
    CountryType["WS"] = "WS";
    CountryType["GD"] = "GD";
    CountryType["GE"] = "GE";
    CountryType["GF"] = "GF";
    CountryType["GH"] = "GH";
    CountryType["GM"] = "GM";
    CountryType["GN"] = "GN";
    CountryType["GQ"] = "GQ";
    CountryType["GR"] = "GR";
    CountryType["GT"] = "GT";
    CountryType["GW"] = "GW";
    CountryType["GY"] = "GY";
    CountryType["XX"] = "XX";
    CountryType["HN"] = "HN";
    CountryType["HR"] = "HR";
    CountryType["HT"] = "HT";
    CountryType["YE"] = "YE";
    CountryType["HU"] = "HU";
    CountryType["ID"] = "ID";
    CountryType["IE"] = "IE";
    CountryType["IL"] = "IL";
    CountryType["IN"] = "IN";
    CountryType["ZA"] = "ZA";
    CountryType["IQ"] = "IQ";
    CountryType["IR"] = "IR";
    CountryType["IS"] = "IS";
    CountryType["IT"] = "IT";
    CountryType["ZM"] = "ZM";
    CountryType["ZW"] = "ZW";
    CountryType["JM"] = "JM";
    CountryType["JO"] = "JO";
    CountryType["JP"] = "JP";
    CountryType["KE"] = "KE";
    CountryType["KG"] = "KG";
    CountryType["KH"] = "KH";
    CountryType["KI"] = "KI";
    CountryType["KM"] = "KM";
    CountryType["KN"] = "KN";
    CountryType["KP"] = "KP";
    CountryType["KR"] = "KR";
    CountryType["KW"] = "KW";
    CountryType["KY"] = "KY";
    CountryType["KZ"] = "KZ";
    CountryType["LA"] = "LA";
    CountryType["LB"] = "LB";
    CountryType["LC"] = "LC";
    CountryType["LI"] = "LI";
    CountryType["LK"] = "LK";
    CountryType["LR"] = "LR";
    CountryType["LS"] = "LS";
    CountryType["LT"] = "LT";
    CountryType["LU"] = "LU";
    CountryType["LV"] = "LV";
    CountryType["LY"] = "LY";
    CountryType["MA"] = "MA";
    CountryType["MC"] = "MC";
    CountryType["MD"] = "MD";
    CountryType["ME"] = "ME";
    CountryType["MG"] = "MG";
    CountryType["MH"] = "MH";
    CountryType["MK"] = "MK";
    CountryType["ML"] = "ML";
    CountryType["MM"] = "MM";
    CountryType["MN"] = "MN";
    CountryType["MR"] = "MR";
    CountryType["MT"] = "MT";
    CountryType["MU"] = "MU";
    CountryType["MV"] = "MV";
    CountryType["MW"] = "MW";
    CountryType["MX"] = "MX";
    CountryType["MY"] = "MY";
    CountryType["MZ"] = "MZ";
    CountryType["NA"] = "NA";
    CountryType["NE"] = "NE";
    CountryType["NG"] = "NG";
    CountryType["NI"] = "NI";
    CountryType["NL"] = "NL";
    CountryType["NO"] = "NO";
    CountryType["NP"] = "NP";
    CountryType["NR"] = "NR";
    CountryType["NZ"] = "NZ";
    CountryType["OM"] = "OM";
    CountryType["PA"] = "PA";
    CountryType["PE"] = "PE";
    CountryType["PG"] = "PG";
    CountryType["PH"] = "PH";
    CountryType["PK"] = "PK";
    CountryType["PL"] = "PL";
})(CountryType || (CountryType = {}));
export var DebtorTypeEnum;
(function (DebtorTypeEnum) {
    DebtorTypeEnum["INTENT_PERSON_DEBTOR"] = "INTENT_PERSON_DEBTOR";
    DebtorTypeEnum["THIRD_PARTY_DEBTOR"] = "THIRD_PARTY_DEBTOR";
})(DebtorTypeEnum || (DebtorTypeEnum = {}));
export var DepartmentThreeTypeOfBurdenEnum;
(function (DepartmentThreeTypeOfBurdenEnum) {
    DepartmentThreeTypeOfBurdenEnum["LAND_CHARGE"] = "LAND_CHARGE";
    DepartmentThreeTypeOfBurdenEnum["MORTGAGE"] = "MORTGAGE";
})(DepartmentThreeTypeOfBurdenEnum || (DepartmentThreeTypeOfBurdenEnum = {}));
export var DepartmentThreeSecurityTypeEnum;
(function (DepartmentThreeSecurityTypeEnum) {
    DepartmentThreeSecurityTypeEnum["CERTIFICATE"] = "CERTIFICATE";
    DepartmentThreeSecurityTypeEnum["LAND_REGISTER"] = "LAND_REGISTER";
})(DepartmentThreeSecurityTypeEnum || (DepartmentThreeSecurityTypeEnum = {}));
export var DepartmentTwoChargeTypeEnum;
(function (DepartmentTwoChargeTypeEnum) {
    DepartmentTwoChargeTypeEnum["DEMOLITION"] = "DEMOLITION";
    DepartmentTwoChargeTypeEnum["SEWAGE"] = "SEWAGE";
    DepartmentTwoChargeTypeEnum["DISCHARGE"] = "DISCHARGE";
    DepartmentTwoChargeTypeEnum["MINING"] = "MINING";
    DepartmentTwoChargeTypeEnum["RAILROAD"] = "RAILROAD";
    DepartmentTwoChargeTypeEnum["BUILDING_RESTRICTION"] = "BUILDING_RESTRICTION";
    DepartmentTwoChargeTypeEnum["BUILDING_INTERDICTION"] = "BUILDING_INTERDICTION";
    DepartmentTwoChargeTypeEnum["USAGE_RESTRITION"] = "USAGE_RESTRITION";
    DepartmentTwoChargeTypeEnum["USAGE_RIGHT"] = "USAGE_RIGHT";
    DepartmentTwoChargeTypeEnum["MINING_DAMAGE_RENOUNCEMENT"] = "MINING_DAMAGE_RENOUNCEMENT";
    DepartmentTwoChargeTypeEnum["SOIL_PROTECTION_NOTE"] = "SOIL_PROTECTION_NOTE";
    DepartmentTwoChargeTypeEnum["DRILL_AND_PROSPECTION_RIGHT"] = "DRILL_AND_PROSPECTION_RIGHT";
    DepartmentTwoChargeTypeEnum["BREWERY_RIGHT"] = "BREWERY_RIGHT";
    DepartmentTwoChargeTypeEnum["HISTORICAL_MONUMENT_PROTECTION_NOTE"] = "HISTORICAL_MONUMENT_PROTECTION_NOTE";
    DepartmentTwoChargeTypeEnum["DISPOSSESSION_NOTE"] = "DISPOSSESSION_NOTE";
    DepartmentTwoChargeTypeEnum["WINDOW_CLOSING_RIGHT"] = "WINDOW_CLOSING_RIGHT";
    DepartmentTwoChargeTypeEnum["FISHING_AND_FOREST_RIGHT"] = "FISHING_AND_FOREST_RIGHT";
    DepartmentTwoChargeTypeEnum["GASTRONOMY_RIGHT"] = "GASTRONOMY_RIGHT";
    DepartmentTwoChargeTypeEnum["BUILDING_USAGE_RIGHT"] = "BUILDING_USAGE_RIGHT";
    DepartmentTwoChargeTypeEnum["BUSINESS_LIMITATION"] = "BUSINESS_LIMITATION";
    DepartmentTwoChargeTypeEnum["HIGH_VOLTAGE_LINE_RIGHT"] = "HIGH_VOLTAGE_LINE_RIGHT";
    DepartmentTwoChargeTypeEnum["LIQUIDATION_NOTE"] = "LIQUIDATION_NOTE";
    DepartmentTwoChargeTypeEnum["LIFE_ESTATE"] = "LIFE_ESTATE";
    DepartmentTwoChargeTypeEnum["LIFE_ANNUITY"] = "LIFE_ANNUITY";
    DepartmentTwoChargeTypeEnum["SUBSTITUTIONAL_HEIR_NOTE"] = "SUBSTITUTIONAL_HEIR_NOTE";
    DepartmentTwoChargeTypeEnum["LEGACY_ADMINISTRATION_NOTE"] = "LEGACY_ADMINISTRATION_NOTE";
    DepartmentTwoChargeTypeEnum["USUFRUCT"] = "USUFRUCT";
    DepartmentTwoChargeTypeEnum["REPURCHASE_RIGHT"] = "REPURCHASE_RIGHT";
    DepartmentTwoChargeTypeEnum["RETENTION_NOTE"] = "RETENTION_NOTE";
    DepartmentTwoChargeTypeEnum["RETENTION_NOTE_FOR_MUNICIPALITY"] = "RETENTION_NOTE_FOR_MUNICIPALITY";
    DepartmentTwoChargeTypeEnum["DAM_STRUCTURE"] = "DAM_STRUCTURE";
    DepartmentTwoChargeTypeEnum["SUPPORTING_STRUCTURE_RIGHT"] = "SUPPORTING_STRUCTURE_RIGHT";
    DepartmentTwoChargeTypeEnum["GAS_STATION_RIGHT"] = "GAS_STATION_RIGHT";
    DepartmentTwoChargeTypeEnum["TANSFORMER_STATION_RIGHT"] = "TANSFORMER_STATION_RIGHT";
    DepartmentTwoChargeTypeEnum["WILL_EXECUTION_NOTE"] = "WILL_EXECUTION_NOTE";
    DepartmentTwoChargeTypeEnum["REALLOCATION_NOTE"] = "REALLOCATION_NOTE";
    DepartmentTwoChargeTypeEnum["SALE_LIMITATION_FOR_SURVEY_OFFICE"] = "SALE_LIMITATION_FOR_SURVEY_OFFICE";
    DepartmentTwoChargeTypeEnum["DISPOSAL_LIMITATION"] = "DISPOSAL_LIMITATION";
    DepartmentTwoChargeTypeEnum["SETTLEMENT_NOTE_OWNER"] = "SETTLEMENT_NOTE_OWNER";
    DepartmentTwoChargeTypeEnum["SETTLEMENT_NOTE_BUYER"] = "SETTLEMENT_NOTE_BUYER";
    DepartmentTwoChargeTypeEnum["IMMISSION_CONTROL_RENOUNCEMENT"] = "IMMISSION_CONTROL_RENOUNCEMENT";
    DepartmentTwoChargeTypeEnum["NEIGHBOUR_AUTHORIZATION_RENOUNCEMENT"] = "NEIGHBOUR_AUTHORIZATION_RENOUNCEMENT";
    DepartmentTwoChargeTypeEnum["RIGHT_OF_FIRST_REFUSAL"] = "RIGHT_OF_FIRST_REFUSAL";
    DepartmentTwoChargeTypeEnum["HOUSING_TENURE"] = "HOUSING_TENURE";
    DepartmentTwoChargeTypeEnum["OCCUPANCY_RIGHT"] = "OCCUPANCY_RIGHT";
    DepartmentTwoChargeTypeEnum["ADMINISTRATIVE_NOTICE"] = "ADMINISTRATIVE_NOTICE";
    DepartmentTwoChargeTypeEnum["COURT_AUCTION_NOTE"] = "COURT_AUCTION_NOTE";
})(DepartmentTwoChargeTypeEnum || (DepartmentTwoChargeTypeEnum = {}));
export var EstateTypeEnum;
(function (EstateTypeEnum) {
    EstateTypeEnum["APARTMENT"] = "APARTMENT";
    EstateTypeEnum["DETACHED_HOUSE"] = "DETACHED_HOUSE";
    EstateTypeEnum["SEMI_DETACHED_HOUSE"] = "SEMI_DETACHED_HOUSE";
    EstateTypeEnum["TWO_FAMILY_HOUSE"] = "TWO_FAMILY_HOUSE";
    EstateTypeEnum["END_TERRACE_HOUSE"] = "END_TERRACE_HOUSE";
    EstateTypeEnum["MID_TERRACE_HOUSE"] = "MID_TERRACE_HOUSE";
    EstateTypeEnum["APARTMENT_BUILDING"] = "APARTMENT_BUILDING";
    EstateTypeEnum["RESIDENTIAL_AND_COMMERCIAL_BUILDING"] = "RESIDENTIAL_AND_COMMERCIAL_BUILDING";
    EstateTypeEnum["PROPERTY"] = "PROPERTY";
})(EstateTypeEnum || (EstateTypeEnum = {}));
export var EstateCostsTypeEnum;
(function (EstateCostsTypeEnum) {
    EstateCostsTypeEnum["CONSTRUCTION"] = "CONSTRUCTION";
    EstateCostsTypeEnum["PURCHASE"] = "PURCHASE";
    EstateCostsTypeEnum["TAX"] = "TAX";
    EstateCostsTypeEnum["BROKER"] = "BROKER";
    EstateCostsTypeEnum["NOTARY"] = "NOTARY";
    EstateCostsTypeEnum["INVENTORY"] = "INVENTORY";
    EstateCostsTypeEnum["LAND"] = "LAND";
    EstateCostsTypeEnum["INCIDENTALS"] = "INCIDENTALS";
    EstateCostsTypeEnum["DESTRUCTION"] = "DESTRUCTION";
    EstateCostsTypeEnum["OUTSIDE"] = "OUTSIDE";
    EstateCostsTypeEnum["RENOVATION"] = "RENOVATION";
    EstateCostsTypeEnum["EXTRA_EQUIPMENT"] = "EXTRA_EQUIPMENT";
    EstateCostsTypeEnum["OTHER"] = "OTHER";
})(EstateCostsTypeEnum || (EstateCostsTypeEnum = {}));
export var EstateCostsValueEntryFormatEnum;
(function (EstateCostsValueEntryFormatEnum) {
    EstateCostsValueEntryFormatEnum["AMOUNT"] = "AMOUNT";
    EstateCostsValueEntryFormatEnum["PERCENTAGE"] = "PERCENTAGE";
})(EstateCostsValueEntryFormatEnum || (EstateCostsValueEntryFormatEnum = {}));
export var EstateFactTypeEnum;
(function (EstateFactTypeEnum) {
    EstateFactTypeEnum["APARTMENT"] = "APARTMENT";
    EstateFactTypeEnum["DETACHED_HOUSE"] = "DETACHED_HOUSE";
    EstateFactTypeEnum["SEMI_DETACHED_HOUSE"] = "SEMI_DETACHED_HOUSE";
    EstateFactTypeEnum["TWO_FAMILY_HOUSE"] = "TWO_FAMILY_HOUSE";
    EstateFactTypeEnum["END_TERRACE_HOUSE"] = "END_TERRACE_HOUSE";
    EstateFactTypeEnum["MID_TERRACE_HOUSE"] = "MID_TERRACE_HOUSE";
    EstateFactTypeEnum["APARTMENT_BUILDING"] = "APARTMENT_BUILDING";
    EstateFactTypeEnum["RESIDENTIAL_AND_COMMERCIAL_BUILDING"] = "RESIDENTIAL_AND_COMMERCIAL_BUILDING";
    EstateFactTypeEnum["PROPERTY"] = "PROPERTY";
})(EstateFactTypeEnum || (EstateFactTypeEnum = {}));
export var EstateFactUsageEnum;
(function (EstateFactUsageEnum) {
    EstateFactUsageEnum["SELF"] = "SELF";
    EstateFactUsageEnum["RENT"] = "RENT";
    EstateFactUsageEnum["MIXED"] = "MIXED";
})(EstateFactUsageEnum || (EstateFactUsageEnum = {}));
export var EstateOriginAdditionalInformationSourceEnum;
(function (EstateOriginAdditionalInformationSourceEnum) {
    EstateOriginAdditionalInformationSourceEnum["IMMOSCOUT"] = "IMMOSCOUT";
    EstateOriginAdditionalInformationSourceEnum["IMMOWELT"] = "IMMOWELT";
    EstateOriginAdditionalInformationSourceEnum["IMMONET"] = "IMMONET";
    EstateOriginAdditionalInformationSourceEnum["SCOPERTY"] = "SCOPERTY";
    EstateOriginAdditionalInformationSourceEnum["PROPERTY_DEVELOPER"] = "PROPERTY_DEVELOPER";
    EstateOriginAdditionalInformationSourceEnum["OTHER"] = "OTHER";
})(EstateOriginAdditionalInformationSourceEnum || (EstateOriginAdditionalInformationSourceEnum = {}));
export var EstateOriginTypeEnum;
(function (EstateOriginTypeEnum) {
    EstateOriginTypeEnum["PLATFORM"] = "PLATFORM";
    EstateOriginTypeEnum["MANUAL"] = "MANUAL";
    EstateOriginTypeEnum["ESTATEDB"] = "ESTATEDB";
})(EstateOriginTypeEnum || (EstateOriginTypeEnum = {}));
export var EstateParamsStateEnum;
(function (EstateParamsStateEnum) {
    EstateParamsStateEnum["ACTIVE"] = "ACTIVE";
    EstateParamsStateEnum["DELETED"] = "DELETED";
})(EstateParamsStateEnum || (EstateParamsStateEnum = {}));
export var EstateParamsOwnershipEnum;
(function (EstateParamsOwnershipEnum) {
    EstateParamsOwnershipEnum["TO_ACQUIRE"] = "TO_ACQUIRE";
    EstateParamsOwnershipEnum["OWNED"] = "OWNED";
})(EstateParamsOwnershipEnum || (EstateParamsOwnershipEnum = {}));
export var EstateParamsEnergyEfficiencyClassificationAfterModernisationEnum;
(function (EstateParamsEnergyEfficiencyClassificationAfterModernisationEnum) {
    EstateParamsEnergyEfficiencyClassificationAfterModernisationEnum["APLUS"] = "APLUS";
    EstateParamsEnergyEfficiencyClassificationAfterModernisationEnum["A"] = "A";
    EstateParamsEnergyEfficiencyClassificationAfterModernisationEnum["B"] = "B";
    EstateParamsEnergyEfficiencyClassificationAfterModernisationEnum["C"] = "C";
    EstateParamsEnergyEfficiencyClassificationAfterModernisationEnum["D"] = "D";
    EstateParamsEnergyEfficiencyClassificationAfterModernisationEnum["E"] = "E";
    EstateParamsEnergyEfficiencyClassificationAfterModernisationEnum["F"] = "F";
    EstateParamsEnergyEfficiencyClassificationAfterModernisationEnum["G"] = "G";
    EstateParamsEnergyEfficiencyClassificationAfterModernisationEnum["H"] = "H";
})(EstateParamsEnergyEfficiencyClassificationAfterModernisationEnum || (EstateParamsEnergyEfficiencyClassificationAfterModernisationEnum = {}));
export var EstateToCopyCopyAsEnum;
(function (EstateToCopyCopyAsEnum) {
    EstateToCopyCopyAsEnum["BUY_NEW"] = "BUY_NEW";
    EstateToCopyCopyAsEnum["BUY_EXISTING"] = "BUY_EXISTING";
    EstateToCopyCopyAsEnum["BUILD"] = "BUILD";
    EstateToCopyCopyAsEnum["REFINANCE"] = "REFINANCE";
    EstateToCopyCopyAsEnum["RENOVATE"] = "RENOVATE";
    EstateToCopyCopyAsEnum["RAISE_CAPITAL"] = "RAISE_CAPITAL";
    EstateToCopyCopyAsEnum["REAL_ESTATE_ASSET"] = "REAL_ESTATE_ASSET";
})(EstateToCopyCopyAsEnum || (EstateToCopyCopyAsEnum = {}));
export var EstimationSource;
(function (EstimationSource) {
    EstimationSource["STANDARD_GROUND_VALUE_MAP"] = "STANDARD_GROUND_VALUE_MAP";
    EstimationSource["EVALUATION_TEAM"] = "EVALUATION_TEAM";
    EstimationSource["HVB_EXPERTISE"] = "HVB_EXPERTISE";
    EstimationSource["IMMOSCOUT"] = "IMMOSCOUT";
    EstimationSource["IMMOPOOL"] = "IMMOPOOL";
    EstimationSource["LBS_ON_SITE"] = "LBS_ON_SITE";
    EstimationSource["PLOETZ"] = "PLOETZ";
    EstimationSource["IVD_GUIDE"] = "IVD_GUIDE";
    EstimationSource["BANK_LOCAL"] = "BANK_LOCAL";
    EstimationSource["CITY"] = "CITY";
    EstimationSource["OTHER"] = "OTHER";
    EstimationSource["SPRENGNETTER"] = "SPRENGNETTER";
    EstimationSource["ING_OBJECT_VALUATION"] = "ING_OBJECT_VALUATION";
    EstimationSource["ON_GEO"] = "ON_GEO";
    EstimationSource["VDP_RESEARCH"] = "VDP_RESEARCH";
})(EstimationSource || (EstimationSource = {}));
export var ExistingLoanForwardTypeEnum;
(function (ExistingLoanForwardTypeEnum) {
    ExistingLoanForwardTypeEnum["FOLLOW_UP_FINANCING"] = "FOLLOW_UP_FINANCING";
    ExistingLoanForwardTypeEnum["EQUITY"] = "EQUITY";
})(ExistingLoanForwardTypeEnum || (ExistingLoanForwardTypeEnum = {}));
export var ExistingLoanCancelationPeriodEnum;
(function (ExistingLoanCancelationPeriodEnum) {
    ExistingLoanCancelationPeriodEnum["MONTHLY_AT_END_OF_MONTH"] = "MONTHLY_AT_END_OF_MONTH";
    ExistingLoanCancelationPeriodEnum["MONTHLY_TO_THE_DAY"] = "MONTHLY_TO_THE_DAY";
    ExistingLoanCancelationPeriodEnum["THREE_MONTHLY_AT_END_OF_QUARTER"] = "THREE_MONTHLY_AT_END_OF_QUARTER";
    ExistingLoanCancelationPeriodEnum["THREE_MONTHLY_TO_THE_DAY"] = "THREE_MONTHLY_TO_THE_DAY";
})(ExistingLoanCancelationPeriodEnum || (ExistingLoanCancelationPeriodEnum = {}));
export var ExpenseTypeEnum;
(function (ExpenseTypeEnum) {
    ExpenseTypeEnum["LIFEINSURANCE_BURDEN"] = "LIFEINSURANCE_BURDEN";
    ExpenseTypeEnum["HEALTHINSURANCE_BURDEN"] = "HEALTHINSURANCE_BURDEN";
    ExpenseTypeEnum["DISABILITYINSURANCE_BURDEN"] = "DISABILITYINSURANCE_BURDEN";
    ExpenseTypeEnum["ACCIDENTINSURANCE_BURDEN"] = "ACCIDENTINSURANCE_BURDEN";
    ExpenseTypeEnum["CHILD_CARE_BURDEN"] = "CHILD_CARE_BURDEN";
    ExpenseTypeEnum["ADDITIONAL_BURDEN"] = "ADDITIONAL_BURDEN";
    ExpenseTypeEnum["CHILD_ALIMONY"] = "CHILD_ALIMONY";
    ExpenseTypeEnum["MARITAL_ALIMONY"] = "MARITAL_ALIMONY";
    ExpenseTypeEnum["FAMILY_ALIMONY"] = "FAMILY_ALIMONY";
    ExpenseTypeEnum["SEPARATION_ALIMONY"] = "SEPARATION_ALIMONY";
    ExpenseTypeEnum["RENT"] = "RENT";
})(ExpenseTypeEnum || (ExpenseTypeEnum = {}));
export var FinancingReason;
(function (FinancingReason) {
    FinancingReason["BUY_NEW"] = "BUY_NEW";
    FinancingReason["BUY_EXISTING"] = "BUY_EXISTING";
    FinancingReason["BUILD"] = "BUILD";
    FinancingReason["REFINANCE"] = "REFINANCE";
    FinancingReason["RENOVATE"] = "RENOVATE";
    FinancingReason["RAISE_CAPITAL"] = "RAISE_CAPITAL";
})(FinancingReason || (FinancingReason = {}));
export var ForcedSalePreviousOwnerEnum;
(function (ForcedSalePreviousOwnerEnum) {
    ForcedSalePreviousOwnerEnum["FAMILY_MEMBER"] = "FAMILY_MEMBER";
    ForcedSalePreviousOwnerEnum["OTHER"] = "OTHER";
})(ForcedSalePreviousOwnerEnum || (ForcedSalePreviousOwnerEnum = {}));
export var FutureModernisationEnergyEfficiencyStandardEnum;
(function (FutureModernisationEnergyEfficiencyStandardEnum) {
    FutureModernisationEnergyEfficiencyStandardEnum["KFW_EFFIZIENZHAUS_40"] = "KFW_EFFIZIENZHAUS_40";
    FutureModernisationEnergyEfficiencyStandardEnum["KFW_EFFIZIENZHAUS_55"] = "KFW_EFFIZIENZHAUS_55";
    FutureModernisationEnergyEfficiencyStandardEnum["KFW_EFFIZIENZHAUS_70"] = "KFW_EFFIZIENZHAUS_70";
    FutureModernisationEnergyEfficiencyStandardEnum["KFW_EFFIZIENZHAUS_85"] = "KFW_EFFIZIENZHAUS_85";
    FutureModernisationEnergyEfficiencyStandardEnum["KFW_EFFIZIENZHAUS_100"] = "KFW_EFFIZIENZHAUS_100";
    FutureModernisationEnergyEfficiencyStandardEnum["KFW_EFFIZIENZHAUS_DENKMAL"] = "KFW_EFFIZIENZHAUS_DENKMAL";
    FutureModernisationEnergyEfficiencyStandardEnum["OTHER"] = "OTHER";
})(FutureModernisationEnergyEfficiencyStandardEnum || (FutureModernisationEnergyEfficiencyStandardEnum = {}));
export var FutureModernisationNewHeatingTypeEnum;
(function (FutureModernisationNewHeatingTypeEnum) {
    FutureModernisationNewHeatingTypeEnum["GAS_CONDENSING_HEATING"] = "GAS_CONDENSING_HEATING";
    FutureModernisationNewHeatingTypeEnum["GAS_HYBRID_HEATING"] = "GAS_HYBRID_HEATING";
    FutureModernisationNewHeatingTypeEnum["SOLAR_THERMAL_HEATING"] = "SOLAR_THERMAL_HEATING";
    FutureModernisationNewHeatingTypeEnum["HEAT_PUMP"] = "HEAT_PUMP";
    FutureModernisationNewHeatingTypeEnum["BIOMASS_HEATING"] = "BIOMASS_HEATING";
    FutureModernisationNewHeatingTypeEnum["HYBRID_HEATING_WITH_RENEWABLE_ENERGY"] = "HYBRID_HEATING_WITH_RENEWABLE_ENERGY";
    FutureModernisationNewHeatingTypeEnum["BUILDING_NETWORK_25_PERCENTAGE_RENEWABLE"] = "BUILDING_NETWORK_25_PERCENTAGE_RENEWABLE";
    FutureModernisationNewHeatingTypeEnum["BUILDING_NETWORK_55_PERCENTAGE_RENEWABLE"] = "BUILDING_NETWORK_55_PERCENTAGE_RENEWABLE";
    FutureModernisationNewHeatingTypeEnum["OTHER"] = "OTHER";
})(FutureModernisationNewHeatingTypeEnum || (FutureModernisationNewHeatingTypeEnum = {}));
export var FutureModernisationTypeEnum;
(function (FutureModernisationTypeEnum) {
    FutureModernisationTypeEnum["INSULATION"] = "INSULATION";
    FutureModernisationTypeEnum["ROOF"] = "ROOF";
    FutureModernisationTypeEnum["FACADE"] = "FACADE";
    FutureModernisationTypeEnum["WINDOWS_OR_DOORS"] = "WINDOWS_OR_DOORS";
    FutureModernisationTypeEnum["HEAT_PROTECTION"] = "HEAT_PROTECTION";
    FutureModernisationTypeEnum["VENTILATION_SYSTEM"] = "VENTILATION_SYSTEM";
    FutureModernisationTypeEnum["ELECTRICS"] = "ELECTRICS";
    FutureModernisationTypeEnum["DIGITAL_ENERGY_OPTIMISATION"] = "DIGITAL_ENERGY_OPTIMISATION";
    FutureModernisationTypeEnum["HEATING"] = "HEATING";
    FutureModernisationTypeEnum["BATHROOMS"] = "BATHROOMS";
    FutureModernisationTypeEnum["POWER_WATER_HEATINGPIPES"] = "POWER_WATER_HEATINGPIPES";
    FutureModernisationTypeEnum["FLOOR_WALL_STAIRCASES"] = "FLOOR_WALL_STAIRCASES";
    FutureModernisationTypeEnum["STRUCTURE"] = "STRUCTURE";
    FutureModernisationTypeEnum["OTHER"] = "OTHER";
    FutureModernisationTypeEnum["TOTAL"] = "TOTAL";
})(FutureModernisationTypeEnum || (FutureModernisationTypeEnum = {}));
export var HistoricalCountryCode;
(function (HistoricalCountryCode) {
    HistoricalCountryCode["AD"] = "AD";
    HistoricalCountryCode["AE"] = "AE";
    HistoricalCountryCode["AF"] = "AF";
    HistoricalCountryCode["AG"] = "AG";
    HistoricalCountryCode["AI"] = "AI";
    HistoricalCountryCode["AIDJ"] = "AIDJ";
    HistoricalCountryCode["AL"] = "AL";
    HistoricalCountryCode["AM"] = "AM";
    HistoricalCountryCode["ANHH"] = "ANHH";
    HistoricalCountryCode["AO"] = "AO";
    HistoricalCountryCode["AQ"] = "AQ";
    HistoricalCountryCode["AR"] = "AR";
    HistoricalCountryCode["AS"] = "AS";
    HistoricalCountryCode["AT"] = "AT";
    HistoricalCountryCode["AU"] = "AU";
    HistoricalCountryCode["AW"] = "AW";
    HistoricalCountryCode["AX"] = "AX";
    HistoricalCountryCode["AZ"] = "AZ";
    HistoricalCountryCode["BA"] = "BA";
    HistoricalCountryCode["BB"] = "BB";
    HistoricalCountryCode["BD"] = "BD";
    HistoricalCountryCode["BE"] = "BE";
    HistoricalCountryCode["BF"] = "BF";
    HistoricalCountryCode["BG"] = "BG";
    HistoricalCountryCode["BH"] = "BH";
    HistoricalCountryCode["BI"] = "BI";
    HistoricalCountryCode["BJ"] = "BJ";
    HistoricalCountryCode["BL"] = "BL";
    HistoricalCountryCode["BM"] = "BM";
    HistoricalCountryCode["BN"] = "BN";
    HistoricalCountryCode["BO"] = "BO";
    HistoricalCountryCode["BQ"] = "BQ";
    HistoricalCountryCode["BQAQ"] = "BQAQ";
    HistoricalCountryCode["BR"] = "BR";
    HistoricalCountryCode["BS"] = "BS";
    HistoricalCountryCode["BT"] = "BT";
    HistoricalCountryCode["BUMM"] = "BUMM";
    HistoricalCountryCode["BV"] = "BV";
    HistoricalCountryCode["BW"] = "BW";
    HistoricalCountryCode["BY"] = "BY";
    HistoricalCountryCode["BYAA"] = "BYAA";
    HistoricalCountryCode["BZ"] = "BZ";
    HistoricalCountryCode["CA"] = "CA";
    HistoricalCountryCode["CC"] = "CC";
    HistoricalCountryCode["CD"] = "CD";
    HistoricalCountryCode["CF"] = "CF";
    HistoricalCountryCode["CG"] = "CG";
    HistoricalCountryCode["CH"] = "CH";
    HistoricalCountryCode["CI"] = "CI";
    HistoricalCountryCode["CK"] = "CK";
    HistoricalCountryCode["CL"] = "CL";
    HistoricalCountryCode["CM"] = "CM";
    HistoricalCountryCode["CN"] = "CN";
    HistoricalCountryCode["CO"] = "CO";
    HistoricalCountryCode["CR"] = "CR";
    HistoricalCountryCode["CSHH"] = "CSHH";
    HistoricalCountryCode["CSXX"] = "CSXX";
    HistoricalCountryCode["CTKI"] = "CTKI";
    HistoricalCountryCode["CU"] = "CU";
    HistoricalCountryCode["CV"] = "CV";
    HistoricalCountryCode["CW"] = "CW";
    HistoricalCountryCode["CX"] = "CX";
    HistoricalCountryCode["CY"] = "CY";
    HistoricalCountryCode["CZ"] = "CZ";
    HistoricalCountryCode["DDDE"] = "DDDE";
    HistoricalCountryCode["DE"] = "DE";
    HistoricalCountryCode["DJ"] = "DJ";
    HistoricalCountryCode["DK"] = "DK";
    HistoricalCountryCode["DM"] = "DM";
    HistoricalCountryCode["DO"] = "DO";
    HistoricalCountryCode["DYBJ"] = "DYBJ";
    HistoricalCountryCode["DZ"] = "DZ";
    HistoricalCountryCode["EC"] = "EC";
    HistoricalCountryCode["EE"] = "EE";
    HistoricalCountryCode["EG"] = "EG";
    HistoricalCountryCode["EH"] = "EH";
    HistoricalCountryCode["ER"] = "ER";
    HistoricalCountryCode["ES"] = "ES";
    HistoricalCountryCode["ET"] = "ET";
    HistoricalCountryCode["FI"] = "FI";
    HistoricalCountryCode["FJ"] = "FJ";
    HistoricalCountryCode["FK"] = "FK";
    HistoricalCountryCode["FM"] = "FM";
    HistoricalCountryCode["FO"] = "FO";
    HistoricalCountryCode["FQHH"] = "FQHH";
    HistoricalCountryCode["FR"] = "FR";
    HistoricalCountryCode["GA"] = "GA";
    HistoricalCountryCode["GB"] = "GB";
    HistoricalCountryCode["GD"] = "GD";
    HistoricalCountryCode["GE"] = "GE";
    HistoricalCountryCode["GEHH"] = "GEHH";
    HistoricalCountryCode["GF"] = "GF";
    HistoricalCountryCode["GG"] = "GG";
    HistoricalCountryCode["GH"] = "GH";
    HistoricalCountryCode["GI"] = "GI";
    HistoricalCountryCode["GL"] = "GL";
    HistoricalCountryCode["GM"] = "GM";
    HistoricalCountryCode["GN"] = "GN";
    HistoricalCountryCode["GP"] = "GP";
    HistoricalCountryCode["GQ"] = "GQ";
    HistoricalCountryCode["GR"] = "GR";
    HistoricalCountryCode["GS"] = "GS";
    HistoricalCountryCode["GT"] = "GT";
    HistoricalCountryCode["GU"] = "GU";
    HistoricalCountryCode["GW"] = "GW";
    HistoricalCountryCode["GY"] = "GY";
    HistoricalCountryCode["HK"] = "HK";
    HistoricalCountryCode["HM"] = "HM";
    HistoricalCountryCode["HN"] = "HN";
    HistoricalCountryCode["HR"] = "HR";
    HistoricalCountryCode["HT"] = "HT";
    HistoricalCountryCode["HU"] = "HU";
    HistoricalCountryCode["HVBF"] = "HVBF";
    HistoricalCountryCode["ID"] = "ID";
    HistoricalCountryCode["IE"] = "IE";
    HistoricalCountryCode["IL"] = "IL";
    HistoricalCountryCode["IM"] = "IM";
    HistoricalCountryCode["IN"] = "IN";
    HistoricalCountryCode["IO"] = "IO";
    HistoricalCountryCode["IQ"] = "IQ";
    HistoricalCountryCode["IR"] = "IR";
    HistoricalCountryCode["IS"] = "IS";
    HistoricalCountryCode["IT"] = "IT";
    HistoricalCountryCode["JE"] = "JE";
    HistoricalCountryCode["JM"] = "JM";
    HistoricalCountryCode["JO"] = "JO";
    HistoricalCountryCode["JP"] = "JP";
    HistoricalCountryCode["JTUM"] = "JTUM";
    HistoricalCountryCode["KE"] = "KE";
    HistoricalCountryCode["KG"] = "KG";
    HistoricalCountryCode["KH"] = "KH";
    HistoricalCountryCode["KI"] = "KI";
    HistoricalCountryCode["KM"] = "KM";
    HistoricalCountryCode["KN"] = "KN";
    HistoricalCountryCode["KP"] = "KP";
    HistoricalCountryCode["KR"] = "KR";
    HistoricalCountryCode["KW"] = "KW";
    HistoricalCountryCode["KY"] = "KY";
    HistoricalCountryCode["KZ"] = "KZ";
    HistoricalCountryCode["LA"] = "LA";
    HistoricalCountryCode["LB"] = "LB";
    HistoricalCountryCode["LC"] = "LC";
    HistoricalCountryCode["LI"] = "LI";
    HistoricalCountryCode["LK"] = "LK";
    HistoricalCountryCode["LR"] = "LR";
    HistoricalCountryCode["LS"] = "LS";
    HistoricalCountryCode["LT"] = "LT";
    HistoricalCountryCode["LU"] = "LU";
    HistoricalCountryCode["LV"] = "LV";
    HistoricalCountryCode["LY"] = "LY";
    HistoricalCountryCode["MA"] = "MA";
    HistoricalCountryCode["MC"] = "MC";
    HistoricalCountryCode["MD"] = "MD";
    HistoricalCountryCode["ME"] = "ME";
    HistoricalCountryCode["MF"] = "MF";
    HistoricalCountryCode["MG"] = "MG";
    HistoricalCountryCode["MH"] = "MH";
    HistoricalCountryCode["MIUM"] = "MIUM";
    HistoricalCountryCode["MK"] = "MK";
    HistoricalCountryCode["ML"] = "ML";
    HistoricalCountryCode["MM"] = "MM";
    HistoricalCountryCode["MN"] = "MN";
    HistoricalCountryCode["MO"] = "MO";
    HistoricalCountryCode["MP"] = "MP";
    HistoricalCountryCode["MQ"] = "MQ";
    HistoricalCountryCode["MR"] = "MR";
    HistoricalCountryCode["MS"] = "MS";
    HistoricalCountryCode["MT"] = "MT";
    HistoricalCountryCode["MU"] = "MU";
    HistoricalCountryCode["MV"] = "MV";
    HistoricalCountryCode["MW"] = "MW";
    HistoricalCountryCode["MX"] = "MX";
    HistoricalCountryCode["MY"] = "MY";
    HistoricalCountryCode["MZ"] = "MZ";
    HistoricalCountryCode["NA"] = "NA";
    HistoricalCountryCode["NC"] = "NC";
    HistoricalCountryCode["NE"] = "NE";
    HistoricalCountryCode["NF"] = "NF";
    HistoricalCountryCode["NG"] = "NG";
    HistoricalCountryCode["NHVU"] = "NHVU";
    HistoricalCountryCode["NI"] = "NI";
    HistoricalCountryCode["NL"] = "NL";
    HistoricalCountryCode["NO"] = "NO";
    HistoricalCountryCode["NP"] = "NP";
    HistoricalCountryCode["NQAQ"] = "NQAQ";
    HistoricalCountryCode["NR"] = "NR";
    HistoricalCountryCode["NU"] = "NU";
    HistoricalCountryCode["NZ"] = "NZ";
    HistoricalCountryCode["OM"] = "OM";
    HistoricalCountryCode["PA"] = "PA";
    HistoricalCountryCode["PCHH"] = "PCHH";
    HistoricalCountryCode["PE"] = "PE";
    HistoricalCountryCode["PF"] = "PF";
    HistoricalCountryCode["PG"] = "PG";
    HistoricalCountryCode["PH"] = "PH";
    HistoricalCountryCode["PK"] = "PK";
    HistoricalCountryCode["PL"] = "PL";
    HistoricalCountryCode["PM"] = "PM";
    HistoricalCountryCode["PN"] = "PN";
    HistoricalCountryCode["PR"] = "PR";
    HistoricalCountryCode["PS"] = "PS";
    HistoricalCountryCode["PT"] = "PT";
    HistoricalCountryCode["PUUM"] = "PUUM";
    HistoricalCountryCode["PW"] = "PW";
    HistoricalCountryCode["PY"] = "PY";
    HistoricalCountryCode["PZPA"] = "PZPA";
    HistoricalCountryCode["QA"] = "QA";
    HistoricalCountryCode["RE"] = "RE";
    HistoricalCountryCode["RHZW"] = "RHZW";
    HistoricalCountryCode["RO"] = "RO";
    HistoricalCountryCode["RS"] = "RS";
    HistoricalCountryCode["RU"] = "RU";
    HistoricalCountryCode["RW"] = "RW";
    HistoricalCountryCode["SA"] = "SA";
    HistoricalCountryCode["SB"] = "SB";
    HistoricalCountryCode["SC"] = "SC";
    HistoricalCountryCode["SD"] = "SD";
    HistoricalCountryCode["SE"] = "SE";
    HistoricalCountryCode["SG"] = "SG";
    HistoricalCountryCode["SH"] = "SH";
    HistoricalCountryCode["SI"] = "SI";
    HistoricalCountryCode["SJ"] = "SJ";
    HistoricalCountryCode["SK"] = "SK";
    HistoricalCountryCode["SKIN"] = "SKIN";
    HistoricalCountryCode["SL"] = "SL";
    HistoricalCountryCode["SM"] = "SM";
    HistoricalCountryCode["SN"] = "SN";
    HistoricalCountryCode["SO"] = "SO";
    HistoricalCountryCode["SR"] = "SR";
    HistoricalCountryCode["SS"] = "SS";
    HistoricalCountryCode["ST"] = "ST";
    HistoricalCountryCode["SUHH"] = "SUHH";
    HistoricalCountryCode["SV"] = "SV";
    HistoricalCountryCode["SX"] = "SX";
    HistoricalCountryCode["SY"] = "SY";
    HistoricalCountryCode["SZ"] = "SZ";
    HistoricalCountryCode["TC"] = "TC";
    HistoricalCountryCode["TD"] = "TD";
    HistoricalCountryCode["TF"] = "TF";
    HistoricalCountryCode["TG"] = "TG";
    HistoricalCountryCode["TH"] = "TH";
    HistoricalCountryCode["TJ"] = "TJ";
    HistoricalCountryCode["TK"] = "TK";
    HistoricalCountryCode["TL"] = "TL";
    HistoricalCountryCode["TM"] = "TM";
    HistoricalCountryCode["TN"] = "TN";
    HistoricalCountryCode["TO"] = "TO";
    HistoricalCountryCode["TPTL"] = "TPTL";
    HistoricalCountryCode["TR"] = "TR";
    HistoricalCountryCode["TT"] = "TT";
    HistoricalCountryCode["TV"] = "TV";
    HistoricalCountryCode["TW"] = "TW";
    HistoricalCountryCode["TZ"] = "TZ";
    HistoricalCountryCode["UA"] = "UA";
    HistoricalCountryCode["UG"] = "UG";
    HistoricalCountryCode["UM"] = "UM";
    HistoricalCountryCode["US"] = "US";
    HistoricalCountryCode["UY"] = "UY";
    HistoricalCountryCode["UZ"] = "UZ";
    HistoricalCountryCode["VA"] = "VA";
    HistoricalCountryCode["VC"] = "VC";
    HistoricalCountryCode["VDVN"] = "VDVN";
    HistoricalCountryCode["VE"] = "VE";
    HistoricalCountryCode["VG"] = "VG";
    HistoricalCountryCode["VI"] = "VI";
    HistoricalCountryCode["VN"] = "VN";
    HistoricalCountryCode["VU"] = "VU";
    HistoricalCountryCode["WF"] = "WF";
    HistoricalCountryCode["WKUM"] = "WKUM";
    HistoricalCountryCode["WS"] = "WS";
    HistoricalCountryCode["XK"] = "XK";
    HistoricalCountryCode["XX"] = "XX";
    HistoricalCountryCode["YDYE"] = "YDYE";
    HistoricalCountryCode["YE"] = "YE";
    HistoricalCountryCode["YT"] = "YT";
    HistoricalCountryCode["YUCS"] = "YUCS";
    HistoricalCountryCode["ZA"] = "ZA";
    HistoricalCountryCode["ZM"] = "ZM";
    HistoricalCountryCode["ZRCD"] = "ZRCD";
    HistoricalCountryCode["ZW"] = "ZW";
})(HistoricalCountryCode || (HistoricalCountryCode = {}));
export var HouseSpecialFeaturesOfConstructionEnum;
(function (HouseSpecialFeaturesOfConstructionEnum) {
    HouseSpecialFeaturesOfConstructionEnum["NO_SPECIFICS"] = "NO_SPECIFICS";
    HouseSpecialFeaturesOfConstructionEnum["PREFABRICATED_HOUSE"] = "PREFABRICATED_HOUSE";
    HouseSpecialFeaturesOfConstructionEnum["GROW_HOUSE"] = "GROW_HOUSE";
    HouseSpecialFeaturesOfConstructionEnum["SELF_BUILD_HOUSE"] = "SELF_BUILD_HOUSE";
})(HouseSpecialFeaturesOfConstructionEnum || (HouseSpecialFeaturesOfConstructionEnum = {}));
export var HouseConditionEnum;
(function (HouseConditionEnum) {
    HouseConditionEnum["AS_NEW"] = "AS_NEW";
    HouseConditionEnum["WELL_KEPT"] = "WELL_KEPT";
    HouseConditionEnum["SLIGHT_RENOVATION_NEEDED"] = "SLIGHT_RENOVATION_NEEDED";
    HouseConditionEnum["MODERNISATION_NEEDED"] = "MODERNISATION_NEEDED";
    HouseConditionEnum["PARTIAL_RENOVATION_NEEDED"] = "PARTIAL_RENOVATION_NEEDED";
    HouseConditionEnum["TOTAL_RENOVATION_NEEDED"] = "TOTAL_RENOVATION_NEEDED";
})(HouseConditionEnum || (HouseConditionEnum = {}));
export var HouseAtticEnum;
(function (HouseAtticEnum) {
    HouseAtticEnum["EXPANDED"] = "EXPANDED";
    HouseAtticEnum["EXPANDABLE"] = "EXPANDABLE";
    HouseAtticEnum["NOT_EXPANDABLE"] = "NOT_EXPANDABLE";
})(HouseAtticEnum || (HouseAtticEnum = {}));
export var HouseBasementEnum;
(function (HouseBasementEnum) {
    HouseBasementEnum["DEVELOPED"] = "DEVELOPED";
    HouseBasementEnum["PARTIALLY_DEVELOPED"] = "PARTIALLY_DEVELOPED";
    HouseBasementEnum["NONE"] = "NONE";
})(HouseBasementEnum || (HouseBasementEnum = {}));
export var HouseBasementResidentialUseEnum;
(function (HouseBasementResidentialUseEnum) {
    HouseBasementResidentialUseEnum["DEVELOPED"] = "DEVELOPED";
    HouseBasementResidentialUseEnum["PARTIALLY_DEVELOPED"] = "PARTIALLY_DEVELOPED";
    HouseBasementResidentialUseEnum["NONE"] = "NONE";
})(HouseBasementResidentialUseEnum || (HouseBasementResidentialUseEnum = {}));
export var IncomeTypeEnum;
(function (IncomeTypeEnum) {
    IncomeTypeEnum["PENSIONS"] = "PENSIONS";
    IncomeTypeEnum["CHILD_ALLOWANCE"] = "CHILD_ALLOWANCE";
    IncomeTypeEnum["RENTAL"] = "RENTAL";
    IncomeTypeEnum["SHAREHOLDINGS"] = "SHAREHOLDINGS";
    IncomeTypeEnum["CAPITAL_YIELDS"] = "CAPITAL_YIELDS";
    IncomeTypeEnum["OTHER"] = "OTHER";
    IncomeTypeEnum["PARENTAL_MONEY"] = "PARENTAL_MONEY";
    IncomeTypeEnum["CHILD_ALIMONY"] = "CHILD_ALIMONY";
    IncomeTypeEnum["MARITAL_ALIMONY"] = "MARITAL_ALIMONY";
    IncomeTypeEnum["FAMILY_ALIMONY"] = "FAMILY_ALIMONY";
    IncomeTypeEnum["SEPARATION_ALIMONY"] = "SEPARATION_ALIMONY";
    IncomeTypeEnum["AUXILIARY"] = "AUXILIARY";
    IncomeTypeEnum["NET_SALARY"] = "NET_SALARY";
    IncomeTypeEnum["SELF_EMPLOYED"] = "SELF_EMPLOYED";
})(IncomeTypeEnum || (IncomeTypeEnum = {}));
export var IndividualGenderEnum;
(function (IndividualGenderEnum) {
    IndividualGenderEnum["M"] = "M";
    IndividualGenderEnum["F"] = "F";
    IndividualGenderEnum["D"] = "D";
})(IndividualGenderEnum || (IndividualGenderEnum = {}));
export var IndividualTitleEnum;
(function (IndividualTitleEnum) {
    IndividualTitleEnum["DR"] = "DR";
    IndividualTitleEnum["PH_D"] = "PH_D";
    IndividualTitleEnum["PD_DR"] = "PD_DR";
    IndividualTitleEnum["PROF"] = "PROF";
    IndividualTitleEnum["PROF_DR"] = "PROF_DR";
})(IndividualTitleEnum || (IndividualTitleEnum = {}));
export var IndividualMaritalStatusEnum;
(function (IndividualMaritalStatusEnum) {
    IndividualMaritalStatusEnum["SINGLE"] = "SINGLE";
    IndividualMaritalStatusEnum["MARRIED"] = "MARRIED";
    IndividualMaritalStatusEnum["REGISTERED_PARTNER"] = "REGISTERED_PARTNER";
    IndividualMaritalStatusEnum["WIDOWED"] = "WIDOWED";
    IndividualMaritalStatusEnum["DIVORCED"] = "DIVORCED";
    IndividualMaritalStatusEnum["SEPARATED"] = "SEPARATED";
    IndividualMaritalStatusEnum["COHABITING"] = "COHABITING";
})(IndividualMaritalStatusEnum || (IndividualMaritalStatusEnum = {}));
export var IndividualMaritalPropertyStatusEnum;
(function (IndividualMaritalPropertyStatusEnum) {
    IndividualMaritalPropertyStatusEnum["COMMUNITY_OF_ACQUESTS_AND_GAINS"] = "COMMUNITY_OF_ACQUESTS_AND_GAINS";
    IndividualMaritalPropertyStatusEnum["SEPARATE_PROPERTY"] = "SEPARATE_PROPERTY";
    IndividualMaritalPropertyStatusEnum["ABSOLUTE_COMMUNITY_PROPERTY"] = "ABSOLUTE_COMMUNITY_PROPERTY";
})(IndividualMaritalPropertyStatusEnum || (IndividualMaritalPropertyStatusEnum = {}));
export var IndividualHousingSituationEnum;
(function (IndividualHousingSituationEnum) {
    IndividualHousingSituationEnum["RENT"] = "RENT";
    IndividualHousingSituationEnum["MORTGAGE_REPAYMENT"] = "MORTGAGE_REPAYMENT";
    IndividualHousingSituationEnum["PAID_PROPERTY"] = "PAID_PROPERTY";
    IndividualHousingSituationEnum["RENT_FREE"] = "RENT_FREE";
})(IndividualHousingSituationEnum || (IndividualHousingSituationEnum = {}));
export var InitialIntentEstateParamsConstructionCostInvoiceEnum;
(function (InitialIntentEstateParamsConstructionCostInvoiceEnum) {
    InitialIntentEstateParamsConstructionCostInvoiceEnum["PROPERTY_DEVELOPER"] = "PROPERTY_DEVELOPER";
    InitialIntentEstateParamsConstructionCostInvoiceEnum["GENERAL_CONTRACTOR"] = "GENERAL_CONTRACTOR";
    InitialIntentEstateParamsConstructionCostInvoiceEnum["ARCHITECT"] = "ARCHITECT";
    InitialIntentEstateParamsConstructionCostInvoiceEnum["INDIVIDUAL_TRADES"] = "INDIVIDUAL_TRADES";
})(InitialIntentEstateParamsConstructionCostInvoiceEnum || (InitialIntentEstateParamsConstructionCostInvoiceEnum = {}));
export var IntentStatus;
(function (IntentStatus) {
    IntentStatus["IN_WORK"] = "IN_WORK";
    IntentStatus["ACTIVE"] = "ACTIVE";
    IntentStatus["ON_HOLD_BY_CUSTOMER"] = "ON_HOLD_BY_CUSTOMER";
    IntentStatus["DELETED"] = "DELETED";
    IntentStatus["BID_ACCEPTED"] = "BID_ACCEPTED";
    IntentStatus["SUBMITTED_TO_BANK"] = "SUBMITTED_TO_BANK";
    IntentStatus["ON_HOLD_BY_BANK"] = "ON_HOLD_BY_BANK";
    IntentStatus["POSITIVE"] = "POSITIVE";
    IntentStatus["NEGATIVE"] = "NEGATIVE";
})(IntentStatus || (IntentStatus = {}));
export var LeasingLiabilityLeasingLiabilityTypeEnum;
(function (LeasingLiabilityLeasingLiabilityTypeEnum) {
    LeasingLiabilityLeasingLiabilityTypeEnum["PRIVATE"] = "PRIVATE";
    LeasingLiabilityLeasingLiabilityTypeEnum["BUSINESS"] = "BUSINESS";
})(LeasingLiabilityLeasingLiabilityTypeEnum || (LeasingLiabilityLeasingLiabilityTypeEnum = {}));
export var LiabilityTypeEnum;
(function (LiabilityTypeEnum) {
    LiabilityTypeEnum["LEASING"] = "LEASING";
    LiabilityTypeEnum["CREDIT"] = "CREDIT";
})(LiabilityTypeEnum || (LiabilityTypeEnum = {}));
export var LifecycleEventEventTypeEnum;
(function (LifecycleEventEventTypeEnum) {
    LifecycleEventEventTypeEnum["CREATION"] = "CREATION";
    LifecycleEventEventTypeEnum["TERMINATION"] = "TERMINATION";
    LifecycleEventEventTypeEnum["REACTIVATION"] = "REACTIVATION";
    LifecycleEventEventTypeEnum["COMPLETION"] = "COMPLETION";
})(LifecycleEventEventTypeEnum || (LifecycleEventEventTypeEnum = {}));
export var ModernisationTypeEnum;
(function (ModernisationTypeEnum) {
    ModernisationTypeEnum["INSULATION"] = "INSULATION";
    ModernisationTypeEnum["ROOF"] = "ROOF";
    ModernisationTypeEnum["FACADE"] = "FACADE";
    ModernisationTypeEnum["WINDOWS_OR_DOORS"] = "WINDOWS_OR_DOORS";
    ModernisationTypeEnum["HEAT_PROTECTION"] = "HEAT_PROTECTION";
    ModernisationTypeEnum["VENTILATION_SYSTEM"] = "VENTILATION_SYSTEM";
    ModernisationTypeEnum["ELECTRICS"] = "ELECTRICS";
    ModernisationTypeEnum["DIGITAL_ENERGY_OPTIMISATION"] = "DIGITAL_ENERGY_OPTIMISATION";
    ModernisationTypeEnum["HEATING"] = "HEATING";
    ModernisationTypeEnum["BATHROOMS"] = "BATHROOMS";
    ModernisationTypeEnum["POWER_WATER_HEATINGPIPES"] = "POWER_WATER_HEATINGPIPES";
    ModernisationTypeEnum["FLOOR_WALL_STAIRCASES"] = "FLOOR_WALL_STAIRCASES";
    ModernisationTypeEnum["STRUCTURE"] = "STRUCTURE";
    ModernisationTypeEnum["OTHER"] = "OTHER";
    ModernisationTypeEnum["TOTAL"] = "TOTAL";
})(ModernisationTypeEnum || (ModernisationTypeEnum = {}));
export var NeededLoanUsageEnum;
(function (NeededLoanUsageEnum) {
    NeededLoanUsageEnum["WORKING_CAPITAL_LOAN"] = "WORKING_CAPITAL_LOAN";
    NeededLoanUsageEnum["REPAYMENT_OTHER_LOANS"] = "REPAYMENT_OTHER_LOANS";
    NeededLoanUsageEnum["PREPAYMENT_PENALTY"] = "PREPAYMENT_PENALTY";
    NeededLoanUsageEnum["REGENERATIVE_ENERGYSYSTEM"] = "REGENERATIVE_ENERGYSYSTEM";
    NeededLoanUsageEnum["RENOVATE"] = "RENOVATE";
    NeededLoanUsageEnum["BUY"] = "BUY";
    NeededLoanUsageEnum["BUILD"] = "BUILD";
    NeededLoanUsageEnum["REFINANCE"] = "REFINANCE";
    NeededLoanUsageEnum["OTHER"] = "OTHER";
})(NeededLoanUsageEnum || (NeededLoanUsageEnum = {}));
export var OccupationType;
(function (OccupationType) {
    OccupationType["EMPLOYEE"] = "EMPLOYEE";
    OccupationType["WORKER"] = "WORKER";
    OccupationType["UNEMPLOYED"] = "UNEMPLOYED";
    OccupationType["OFFICIAL"] = "OFFICIAL";
    OccupationType["PARENTAL_LEAVE"] = "PARENTAL_LEAVE";
    OccupationType["FREELANCER"] = "FREELANCER";
    OccupationType["MARGINALLY_EMPLOYED"] = "MARGINALLY_EMPLOYED";
    OccupationType["STOCKHOLDER"] = "STOCKHOLDER";
    OccupationType["HOUSE_WIFE_OR_HUSBAND"] = "HOUSE_WIFE_OR_HUSBAND";
    OccupationType["PERSON_OF_INDEPENDENT_MEANS"] = "PERSON_OF_INDEPENDENT_MEANS";
    OccupationType["SELF_EMPLOYED_WITH_BALANCING"] = "SELF_EMPLOYED_WITH_BALANCING";
    OccupationType["SELF_EMPLOYED_WITHOUT_BALANCING"] = "SELF_EMPLOYED_WITHOUT_BALANCING";
    OccupationType["PENSIONER"] = "PENSIONER";
    OccupationType["STUDENT"] = "STUDENT";
    OccupationType["SOLDIER"] = "SOLDIER";
    OccupationType["EXECUTIVE"] = "EXECUTIVE";
})(OccupationType || (OccupationType = {}));
export var ParkingSpaceTypeEnum;
(function (ParkingSpaceTypeEnum) {
    ParkingSpaceTypeEnum["SURFACE"] = "SURFACE";
    ParkingSpaceTypeEnum["CARPORT"] = "CARPORT";
    ParkingSpaceTypeEnum["DUPLEX"] = "DUPLEX";
    ParkingSpaceTypeEnum["UNDERGROUND"] = "UNDERGROUND";
    ParkingSpaceTypeEnum["DOUBLE"] = "DOUBLE";
    ParkingSpaceTypeEnum["SINGLE"] = "SINGLE";
})(ParkingSpaceTypeEnum || (ParkingSpaceTypeEnum = {}));
export var PatchRequestOpEnum;
(function (PatchRequestOpEnum) {
    PatchRequestOpEnum["add"] = "add";
    PatchRequestOpEnum["remove"] = "remove";
    PatchRequestOpEnum["replace"] = "replace";
    PatchRequestOpEnum["move"] = "move";
    PatchRequestOpEnum["copy"] = "copy";
    PatchRequestOpEnum["test"] = "test";
})(PatchRequestOpEnum || (PatchRequestOpEnum = {}));
export var PayoutPaymentsReasonEnum;
(function (PayoutPaymentsReasonEnum) {
    PayoutPaymentsReasonEnum["PRICE_PAYMENT"] = "PRICE_PAYMENT";
    PayoutPaymentsReasonEnum["MODERNISATION"] = "MODERNISATION";
    PayoutPaymentsReasonEnum["MABV_INSTALLMENT"] = "MABV_INSTALLMENT";
})(PayoutPaymentsReasonEnum || (PayoutPaymentsReasonEnum = {}));
export var PersonFactGenderEnum;
(function (PersonFactGenderEnum) {
    PersonFactGenderEnum["M"] = "M";
    PersonFactGenderEnum["F"] = "F";
    PersonFactGenderEnum["D"] = "D";
})(PersonFactGenderEnum || (PersonFactGenderEnum = {}));
export var PersonFactTitleEnum;
(function (PersonFactTitleEnum) {
    PersonFactTitleEnum["DR"] = "DR";
    PersonFactTitleEnum["PH_D"] = "PH_D";
    PersonFactTitleEnum["PD_DR"] = "PD_DR";
    PersonFactTitleEnum["PROF"] = "PROF";
    PersonFactTitleEnum["PROF_DR"] = "PROF_DR";
})(PersonFactTitleEnum || (PersonFactTitleEnum = {}));
export var PersonParamsStateEnum;
(function (PersonParamsStateEnum) {
    PersonParamsStateEnum["ACTIVE"] = "ACTIVE";
    PersonParamsStateEnum["DELETED"] = "DELETED";
})(PersonParamsStateEnum || (PersonParamsStateEnum = {}));
export var PersonParamsMortgageExperienceEnum;
(function (PersonParamsMortgageExperienceEnum) {
    PersonParamsMortgageExperienceEnum["WITH_EXPERIENCE"] = "WITH_EXPERIENCE";
    PersonParamsMortgageExperienceEnum["WITHOUT_EXPERIENCE"] = "WITHOUT_EXPERIENCE";
})(PersonParamsMortgageExperienceEnum || (PersonParamsMortgageExperienceEnum = {}));
export var PlotOfLandGroundTypeEnum;
(function (PlotOfLandGroundTypeEnum) {
    PlotOfLandGroundTypeEnum["BUILDING_LAND"] = "BUILDING_LAND";
    PlotOfLandGroundTypeEnum["EXPECTED_BUILDING_LAND"] = "EXPECTED_BUILDING_LAND";
    PlotOfLandGroundTypeEnum["OTHER"] = "OTHER";
})(PlotOfLandGroundTypeEnum || (PlotOfLandGroundTypeEnum = {}));
export var ProcessProcessorsRoleEnum;
(function (ProcessProcessorsRoleEnum) {
    ProcessProcessorsRoleEnum["ADVISOR"] = "ADVISOR";
    ProcessProcessorsRoleEnum["SUPPORTER"] = "SUPPORTER";
    ProcessProcessorsRoleEnum["CLEARER"] = "CLEARER";
})(ProcessProcessorsRoleEnum || (ProcessProcessorsRoleEnum = {}));
export var ProcessStatus;
(function (ProcessStatus) {
    ProcessStatus["ACTIVE"] = "ACTIVE";
    ProcessStatus["POSITIVE"] = "POSITIVE";
    ProcessStatus["NEGATIVE"] = "NEGATIVE";
})(ProcessStatus || (ProcessStatus = {}));
export var ProvinceType;
(function (ProvinceType) {
    ProvinceType["DE_BW"] = "DE_BW";
    ProvinceType["DE_BY"] = "DE_BY";
    ProvinceType["DE_BE"] = "DE_BE";
    ProvinceType["DE_BB"] = "DE_BB";
    ProvinceType["DE_HB"] = "DE_HB";
    ProvinceType["DE_HH"] = "DE_HH";
    ProvinceType["DE_HE"] = "DE_HE";
    ProvinceType["DE_MV"] = "DE_MV";
    ProvinceType["DE_NI"] = "DE_NI";
    ProvinceType["DE_NW"] = "DE_NW";
    ProvinceType["DE_RP"] = "DE_RP";
    ProvinceType["DE_SL"] = "DE_SL";
    ProvinceType["DE_SN"] = "DE_SN";
    ProvinceType["DE_ST"] = "DE_ST";
    ProvinceType["DE_SH"] = "DE_SH";
    ProvinceType["DE_TH"] = "DE_TH";
})(ProvinceType || (ProvinceType = {}));
export var RelationshipOwnRoleEnum;
(function (RelationshipOwnRoleEnum) {
    RelationshipOwnRoleEnum["PARENT"] = "PARENT";
    RelationshipOwnRoleEnum["SPOUSE"] = "SPOUSE";
    RelationshipOwnRoleEnum["LEGALPARTNER"] = "LEGALPARTNER";
    RelationshipOwnRoleEnum["PARTNER"] = "PARTNER";
    RelationshipOwnRoleEnum["DIVORCEE"] = "DIVORCEE";
    RelationshipOwnRoleEnum["THIRD_PARTY"] = "THIRD_PARTY";
})(RelationshipOwnRoleEnum || (RelationshipOwnRoleEnum = {}));
export var RentalUnitGroupRentedPeriodEnum;
(function (RentalUnitGroupRentedPeriodEnum) {
    RentalUnitGroupRentedPeriodEnum["TEMPORARY"] = "TEMPORARY";
    RentalUnitGroupRentedPeriodEnum["UNLIMITED"] = "UNLIMITED";
    RentalUnitGroupRentedPeriodEnum["NONE"] = "NONE";
})(RentalUnitGroupRentedPeriodEnum || (RentalUnitGroupRentedPeriodEnum = {}));
export var RoofRoofTypeEnum;
(function (RoofRoofTypeEnum) {
    RoofRoofTypeEnum["ROOFING_FELT"] = "ROOFING_FELT";
    RoofRoofTypeEnum["ROOF_TILES"] = "ROOF_TILES";
    RoofRoofTypeEnum["ARTIFICAL_SLATE"] = "ARTIFICAL_SLATE";
    RoofRoofTypeEnum["SLATE_OR_METAL"] = "SLATE_OR_METAL";
    RoofRoofTypeEnum["OTHER"] = "OTHER";
})(RoofRoofTypeEnum || (RoofRoofTypeEnum = {}));
export var SchufaRatingEnum;
(function (SchufaRatingEnum) {
    SchufaRatingEnum["A"] = "A";
    SchufaRatingEnum["B"] = "B";
    SchufaRatingEnum["C"] = "C";
    SchufaRatingEnum["D"] = "D";
    SchufaRatingEnum["E"] = "E";
    SchufaRatingEnum["F"] = "F";
    SchufaRatingEnum["G"] = "G";
    SchufaRatingEnum["H"] = "H";
    SchufaRatingEnum["I"] = "I";
    SchufaRatingEnum["J"] = "J";
    SchufaRatingEnum["K"] = "K";
    SchufaRatingEnum["L"] = "L";
    SchufaRatingEnum["M"] = "M";
})(SchufaRatingEnum || (SchufaRatingEnum = {}));
export var SelfEmploymentIncomeProfitMethodEnum;
(function (SelfEmploymentIncomeProfitMethodEnum) {
    SelfEmploymentIncomeProfitMethodEnum["CUSTOMER_STATEMENT"] = "CUSTOMER_STATEMENT";
    SelfEmploymentIncomeProfitMethodEnum["ANNUAL_FINANCIAL_STATEMENTS"] = "ANNUAL_FINANCIAL_STATEMENTS";
})(SelfEmploymentIncomeProfitMethodEnum || (SelfEmploymentIncomeProfitMethodEnum = {}));
export var SelfEmploymentIncomeItemMethodEnum;
(function (SelfEmploymentIncomeItemMethodEnum) {
    SelfEmploymentIncomeItemMethodEnum["ECONOMIC_EVALUATION"] = "ECONOMIC_EVALUATION";
    SelfEmploymentIncomeItemMethodEnum["ANNUAL_FINANCIAL_STATEMENT"] = "ANNUAL_FINANCIAL_STATEMENT";
})(SelfEmploymentIncomeItemMethodEnum || (SelfEmploymentIncomeItemMethodEnum = {}));
export var SimpleLiabilityTypeEnum;
(function (SimpleLiabilityTypeEnum) {
    SimpleLiabilityTypeEnum["GUARANTEE"] = "GUARANTEE";
    SimpleLiabilityTypeEnum["OTHER"] = "OTHER";
})(SimpleLiabilityTypeEnum || (SimpleLiabilityTypeEnum = {}));
export var SpecialAttribute;
(function (SpecialAttribute) {
    SpecialAttribute["LUXURY"] = "LUXURY";
    SpecialAttribute["FARM"] = "FARM";
    SpecialAttribute["HOLIDAY_PROPERTY"] = "HOLIDAY_PROPERTY";
    SpecialAttribute["MONUMENT_PROTECTION"] = "MONUMENT_PROTECTION";
    SpecialAttribute["MICRO_APARTMENT"] = "MICRO_APARTMENT";
    SpecialAttribute["TINY_HOUSE"] = "TINY_HOUSE";
    SpecialAttribute["CARE_PROPERTY"] = "CARE_PROPERTY";
    SpecialAttribute["RETIREMENT_RESIDENCE"] = "RETIREMENT_RESIDENCE";
})(SpecialAttribute || (SpecialAttribute = {}));
export var SpecialAttributesAcquisition;
(function (SpecialAttributesAcquisition) {
    SpecialAttributesAcquisition["SEPERATED_ACCORDING_WEG"] = "SEPERATED_ACCORDING_WEG";
    SpecialAttributesAcquisition["FAMILY_SALE"] = "FAMILY_SALE";
    SpecialAttributesAcquisition["FRACTIONAL_OWNERSHIP"] = "FRACTIONAL_OWNERSHIP";
})(SpecialAttributesAcquisition || (SpecialAttributesAcquisition = {}));
export var SpecialPropertyPropertyEnum;
(function (SpecialPropertyPropertyEnum) {
    SpecialPropertyPropertyEnum["BASEMENT"] = "BASEMENT";
    SpecialPropertyPropertyEnum["BASEMENT_HOBBY_ROOM"] = "BASEMENT_HOBBY_ROOM";
    SpecialPropertyPropertyEnum["DRY_ROOM"] = "DRY_ROOM";
    SpecialPropertyPropertyEnum["ATTIC"] = "ATTIC";
    SpecialPropertyPropertyEnum["OFFICE"] = "OFFICE";
    SpecialPropertyPropertyEnum["FLAT"] = "FLAT";
    SpecialPropertyPropertyEnum["ALL"] = "ALL";
    SpecialPropertyPropertyEnum["GARAGE"] = "GARAGE";
    SpecialPropertyPropertyEnum["PARKINGSPACE"] = "PARKINGSPACE";
    SpecialPropertyPropertyEnum["UNDERGROUND_GARAGE"] = "UNDERGROUND_GARAGE";
    SpecialPropertyPropertyEnum["DUPLEX_GARAGE"] = "DUPLEX_GARAGE";
    SpecialPropertyPropertyEnum["PLOT_OF_LAND"] = "PLOT_OF_LAND";
    SpecialPropertyPropertyEnum["END_TERRACE_HOUSE"] = "END_TERRACE_HOUSE";
    SpecialPropertyPropertyEnum["MID_TERRACE_HOUSE"] = "MID_TERRACE_HOUSE";
    SpecialPropertyPropertyEnum["SEMI_DETACHED_HOUSE"] = "SEMI_DETACHED_HOUSE";
})(SpecialPropertyPropertyEnum || (SpecialPropertyPropertyEnum = {}));
export var TerminationReason;
(function (TerminationReason) {
    TerminationReason["PROCESS_DURATION"] = "PROCESS_DURATION";
    TerminationReason["MISSING_REACTION_CUSTOMER"] = "MISSING_REACTION_CUSTOMER";
    TerminationReason["ESTATE_LOST"] = "ESTATE_LOST";
    TerminationReason["SPECIAL_STRUCTURE"] = "SPECIAL_STRUCTURE";
    TerminationReason["DOCUMENT_SCOPE"] = "DOCUMENT_SCOPE";
    TerminationReason["DURATION_SELFEMPLOYMENT"] = "DURATION_SELFEMPLOYMENT";
    TerminationReason["MISSING_REACTION_BROKER"] = "MISSING_REACTION_BROKER";
    TerminationReason["OVERALL_CONSTELLATION"] = "OVERALL_CONSTELLATION";
    TerminationReason["NEGATIVE_HOUSEHOLD_CALCULATION"] = "NEGATIVE_HOUSEHOLD_CALCULATION";
    TerminationReason["NEGATIVE_CREDIT_HISTORY"] = "NEGATIVE_CREDIT_HISTORY";
    TerminationReason["NEGATIVE_SCHUFA"] = "NEGATIVE_SCHUFA";
    TerminationReason["NEGATIV_CAPITAL"] = "NEGATIV_CAPITAL";
    TerminationReason["ESTATE_VALUATION_BLA"] = "ESTATE_VALUATION_BLA";
    TerminationReason["PROBATION"] = "PROBATION";
    TerminationReason["OTHER"] = "OTHER";
})(TerminationReason || (TerminationReason = {}));
export var TerminationType;
(function (TerminationType) {
    TerminationType["CUSTOMER_CANCEL"] = "CUSTOMER_CANCEL";
    TerminationType["BROKER_CANCEL"] = "BROKER_CANCEL";
    TerminationType["REJECT_BY_US"] = "REJECT_BY_US";
})(TerminationType || (TerminationType = {}));
export var ThirdPartyDebtorGenderEnum;
(function (ThirdPartyDebtorGenderEnum) {
    ThirdPartyDebtorGenderEnum["M"] = "M";
    ThirdPartyDebtorGenderEnum["F"] = "F";
    ThirdPartyDebtorGenderEnum["D"] = "D";
})(ThirdPartyDebtorGenderEnum || (ThirdPartyDebtorGenderEnum = {}));
export var ThirdPartyDebtorTitleEnum;
(function (ThirdPartyDebtorTitleEnum) {
    ThirdPartyDebtorTitleEnum["DR"] = "DR";
    ThirdPartyDebtorTitleEnum["PH_D"] = "PH_D";
    ThirdPartyDebtorTitleEnum["PD_DR"] = "PD_DR";
    ThirdPartyDebtorTitleEnum["PROF"] = "PROF";
    ThirdPartyDebtorTitleEnum["PROF_DR"] = "PROF_DR";
})(ThirdPartyDebtorTitleEnum || (ThirdPartyDebtorTitleEnum = {}));
export var UnitGroupTypeEnum;
(function (UnitGroupTypeEnum) {
    UnitGroupTypeEnum["RESIDENTIAL"] = "RESIDENTIAL";
    UnitGroupTypeEnum["COMMERCIAL"] = "COMMERCIAL";
})(UnitGroupTypeEnum || (UnitGroupTypeEnum = {}));
export var UnitGroupUsageEnum;
(function (UnitGroupUsageEnum) {
    UnitGroupUsageEnum["SELF"] = "SELF";
    UnitGroupUsageEnum["RENT"] = "RENT";
})(UnitGroupUsageEnum || (UnitGroupUsageEnum = {}));
export var UnitGroupCommerceTypeEnum;
(function (UnitGroupCommerceTypeEnum) {
    UnitGroupCommerceTypeEnum["RETAIL_STORE"] = "RETAIL_STORE";
    UnitGroupCommerceTypeEnum["DOCTORS_OFFICE"] = "DOCTORS_OFFICE";
    UnitGroupCommerceTypeEnum["REGULAR_OFFICE"] = "REGULAR_OFFICE";
    UnitGroupCommerceTypeEnum["WORKSHOP_OR_GARAGE"] = "WORKSHOP_OR_GARAGE";
    UnitGroupCommerceTypeEnum["WAREHOUSE"] = "WAREHOUSE";
    UnitGroupCommerceTypeEnum["GASTRONOMY"] = "GASTRONOMY";
    UnitGroupCommerceTypeEnum["HOTEL_OR_PENSION"] = "HOTEL_OR_PENSION";
    UnitGroupCommerceTypeEnum["VIDEO_OR_GAMEROOM"] = "VIDEO_OR_GAMEROOM";
    UnitGroupCommerceTypeEnum["NIGHT_SPOT"] = "NIGHT_SPOT";
    UnitGroupCommerceTypeEnum["RED_LIGHT"] = "RED_LIGHT";
    UnitGroupCommerceTypeEnum["GAS_STATION"] = "GAS_STATION";
    UnitGroupCommerceTypeEnum["BETTING_OFFICE"] = "BETTING_OFFICE";
    UnitGroupCommerceTypeEnum["TANNING_OR_FITNESS"] = "TANNING_OR_FITNESS";
    UnitGroupCommerceTypeEnum["TAXI_COMPANY"] = "TAXI_COMPANY";
    UnitGroupCommerceTypeEnum["TRANSPORT_BUSINESS"] = "TRANSPORT_BUSINESS";
    UnitGroupCommerceTypeEnum["CONSTRUCTION_INDUSTRY"] = "CONSTRUCTION_INDUSTRY";
    UnitGroupCommerceTypeEnum["HAIRDRESSER"] = "HAIRDRESSER";
    UnitGroupCommerceTypeEnum["OTHER"] = "OTHER";
})(UnitGroupCommerceTypeEnum || (UnitGroupCommerceTypeEnum = {}));
export var VariableIncomeTypeEnum;
(function (VariableIncomeTypeEnum) {
    VariableIncomeTypeEnum["ABROAD_PREMIUM"] = "ABROAD_PREMIUM";
    VariableIncomeTypeEnum["PROFIT_SHARING"] = "PROFIT_SHARING";
    VariableIncomeTypeEnum["COMMISSIONS"] = "COMMISSIONS";
    VariableIncomeTypeEnum["SHIFT_PREMIUMS"] = "SHIFT_PREMIUMS";
    VariableIncomeTypeEnum["OVERTIME"] = "OVERTIME";
    VariableIncomeTypeEnum["BONUS_PREMIUMS"] = "BONUS_PREMIUMS";
    VariableIncomeTypeEnum["TRAVEL_ALLOWANCE"] = "TRAVEL_ALLOWANCE";
    VariableIncomeTypeEnum["OTHER"] = "OTHER";
})(VariableIncomeTypeEnum || (VariableIncomeTypeEnum = {}));
export const InfoApiAxiosParamCreator = function (configuration) {
    return {
        getServiceInfo: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const InfoApiFp = function (configuration) {
    return {
        getServiceInfo(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield InfoApiAxiosParamCreator(configuration).getServiceInfo(options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
    };
};
export const InfoApiFactory = function (configuration, basePath, axios) {
    return {
        getServiceInfo(options) {
            return InfoApiFp(configuration).getServiceInfo(options).then((request) => request(axios, basePath));
        },
    };
};
export class InfoApi extends BaseAPI {
    getServiceInfo(options) {
        return InfoApiFp(this.configuration).getServiceInfo(options).then((request) => request(this.axios, this.basePath));
    }
}
export const IntentApiAxiosParamCreator = function (configuration) {
    return {
        copyIntent: (intentCopyRequest_1, ...args_1) => __awaiter(this, [intentCopyRequest_1, ...args_1], void 0, function* (intentCopyRequest, options = {}) {
            if (intentCopyRequest === null || intentCopyRequest === undefined) {
                throw new RequiredError('intentCopyRequest', 'Required parameter intentCopyRequest was null or undefined when calling copyIntent.');
            }
            const localVarPath = `/mortgage-intent/v1/intents/copy`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof intentCopyRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(intentCopyRequest !== undefined ? intentCopyRequest : {}) : (intentCopyRequest || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        createIntent: (intentCreationRequest_1, ...args_1) => __awaiter(this, [intentCreationRequest_1, ...args_1], void 0, function* (intentCreationRequest, options = {}) {
            if (intentCreationRequest === null || intentCreationRequest === undefined) {
                throw new RequiredError('intentCreationRequest', 'Required parameter intentCreationRequest was null or undefined when calling createIntent.');
            }
            const localVarPath = `/mortgage-intent/v1/intents`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof intentCreationRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(intentCreationRequest !== undefined ? intentCreationRequest : {}) : (intentCreationRequest || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        exportIntents: (createdAfter_1, createdUntil_1, updatedAfter_1, updatedUntil_1, status_1, embed_1, limit_1, cursorBefore_1, cursorAfter_1, ...args_1) => __awaiter(this, [createdAfter_1, createdUntil_1, updatedAfter_1, updatedUntil_1, status_1, embed_1, limit_1, cursorBefore_1, cursorAfter_1, ...args_1], void 0, function* (createdAfter, createdUntil, updatedAfter, updatedUntil, status, embed, limit, cursorBefore, cursorAfter, options = {}) {
            const localVarPath = `/mortgage-intent/v1/intents/export`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (createdAfter !== undefined) {
                localVarQueryParameter['createdAfter'] = (createdAfter instanceof Date) ?
                    createdAfter.toISOString() :
                    createdAfter;
            }
            if (createdUntil !== undefined) {
                localVarQueryParameter['createdUntil'] = (createdUntil instanceof Date) ?
                    createdUntil.toISOString() :
                    createdUntil;
            }
            if (updatedAfter !== undefined) {
                localVarQueryParameter['updatedAfter'] = (updatedAfter instanceof Date) ?
                    updatedAfter.toISOString() :
                    updatedAfter;
            }
            if (updatedUntil !== undefined) {
                localVarQueryParameter['updatedUntil'] = (updatedUntil instanceof Date) ?
                    updatedUntil.toISOString() :
                    updatedUntil;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (embed !== undefined) {
                localVarQueryParameter['embed'] = embed;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (cursorBefore !== undefined) {
                localVarQueryParameter['cursorBefore'] = cursorBefore;
            }
            if (cursorAfter !== undefined) {
                localVarQueryParameter['cursorAfter'] = cursorAfter;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        filterForIntents: (filterRequest_1, ...args_1) => __awaiter(this, [filterRequest_1, ...args_1], void 0, function* (filterRequest, options = {}) {
            if (filterRequest === null || filterRequest === undefined) {
                throw new RequiredError('filterRequest', 'Required parameter filterRequest was null or undefined when calling filterForIntents.');
            }
            const localVarPath = `/mortgage-intent/v1/intents/filter`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof filterRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(filterRequest !== undefined ? filterRequest : {}) : (filterRequest || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getEstate: (id_1, estateId_1, ...args_1) => __awaiter(this, [id_1, estateId_1, ...args_1], void 0, function* (id, estateId, options = {}) {
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getEstate.');
            }
            if (estateId === null || estateId === undefined) {
                throw new RequiredError('estateId', 'Required parameter estateId was null or undefined when calling getEstate.');
            }
            const localVarPath = `/mortgage-intent/v1/intents/{id}/estates/{estateId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"estateId"}}`, encodeURIComponent(String(estateId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getIntent: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getIntent.');
            }
            const localVarPath = `/mortgage-intent/v1/intents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getIntentInfo: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getIntentInfo.');
            }
            const localVarPath = `/mortgage-intent/v1/intents/{id}/info`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getIntentInfoByCaseId: (caseId_1, ...args_1) => __awaiter(this, [caseId_1, ...args_1], void 0, function* (caseId, options = {}) {
            if (caseId === null || caseId === undefined) {
                throw new RequiredError('caseId', 'Required parameter caseId was null or undefined when calling getIntentInfoByCaseId.');
            }
            const localVarPath = `/mortgage-intent/v1/intents/intent-info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (caseId !== undefined) {
                localVarQueryParameter['caseId'] = caseId;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getIntentPermission: (id_1, action_1, ...args_1) => __awaiter(this, [id_1, action_1, ...args_1], void 0, function* (id, action, options = {}) {
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getIntentPermission.');
            }
            if (action === null || action === undefined) {
                throw new RequiredError('action', 'Required parameter action was null or undefined when calling getIntentPermission.');
            }
            const localVarPath = `/mortgage-intent/v1/intents/{id}/permission/{action}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"action"}}`, encodeURIComponent(String(action)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getIntentProcess: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getIntentProcess.');
            }
            const localVarPath = `/mortgage-intent/v1/intents/{id}/process`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        intentsOfAuthenticatedCustomer: (limit_1, cursorBefore_1, cursorAfter_1, ...args_1) => __awaiter(this, [limit_1, cursorBefore_1, cursorAfter_1, ...args_1], void 0, function* (limit, cursorBefore, cursorAfter, options = {}) {
            const localVarPath = `/mortgage-intent/v1/intents/mine`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (cursorBefore !== undefined) {
                localVarQueryParameter['cursorBefore'] = cursorBefore;
            }
            if (cursorAfter !== undefined) {
                localVarQueryParameter['cursorAfter'] = cursorAfter;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        intentsOfAuthenticatedUser: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/mortgage-intent/v1/intents/info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        patchIntent: (id_1, patchRequest_1, ...args_1) => __awaiter(this, [id_1, patchRequest_1, ...args_1], void 0, function* (id, patchRequest, options = {}) {
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchIntent.');
            }
            if (patchRequest === null || patchRequest === undefined) {
                throw new RequiredError('patchRequest', 'Required parameter patchRequest was null or undefined when calling patchIntent.');
            }
            const localVarPath = `/mortgage-intent/v1/intents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof patchRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(patchRequest !== undefined ? patchRequest : {}) : (patchRequest || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        reactivateIntent: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling reactivateIntent.');
            }
            const localVarPath = `/mortgage-intent/v1/intents/{id}/termination`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        searchByCaseId: (caseId_1, ...args_1) => __awaiter(this, [caseId_1, ...args_1], void 0, function* (caseId, options = {}) {
            if (caseId === null || caseId === undefined) {
                throw new RequiredError('caseId', 'Required parameter caseId was null or undefined when calling searchByCaseId.');
            }
            const localVarPath = `/mortgage-intent/v1/intents`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (caseId !== undefined) {
                localVarQueryParameter['caseId'] = caseId;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        switchIntentStatus: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling switchIntentStatus.');
            }
            const localVarPath = `/mortgage-intent/v1/intents/{id}/status-active`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        terminateIntent: (id_1, intentTerminationRequest_1, ...args_1) => __awaiter(this, [id_1, intentTerminationRequest_1, ...args_1], void 0, function* (id, intentTerminationRequest, options = {}) {
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling terminateIntent.');
            }
            if (intentTerminationRequest === null || intentTerminationRequest === undefined) {
                throw new RequiredError('intentTerminationRequest', 'Required parameter intentTerminationRequest was null or undefined when calling terminateIntent.');
            }
            const localVarPath = `/mortgage-intent/v1/intents/{id}/termination`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof intentTerminationRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(intentTerminationRequest !== undefined ? intentTerminationRequest : {}) : (intentTerminationRequest || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        validate: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling validate.');
            }
            const localVarPath = `/mortgage-intent/v1/intents/{id}/validate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const IntentApiFp = function (configuration) {
    return {
        copyIntent(intentCopyRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).copyIntent(intentCopyRequest, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        createIntent(intentCreationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).createIntent(intentCreationRequest, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        exportIntents(createdAfter, createdUntil, updatedAfter, updatedUntil, status, embed, limit, cursorBefore, cursorAfter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).exportIntents(createdAfter, createdUntil, updatedAfter, updatedUntil, status, embed, limit, cursorBefore, cursorAfter, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        filterForIntents(filterRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).filterForIntents(filterRequest, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        getEstate(id, estateId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).getEstate(id, estateId, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        getIntent(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).getIntent(id, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        getIntentInfo(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).getIntentInfo(id, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        getIntentInfoByCaseId(caseId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).getIntentInfoByCaseId(caseId, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        getIntentPermission(id, action, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).getIntentPermission(id, action, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        getIntentProcess(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).getIntentProcess(id, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        intentsOfAuthenticatedCustomer(limit, cursorBefore, cursorAfter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).intentsOfAuthenticatedCustomer(limit, cursorBefore, cursorAfter, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        intentsOfAuthenticatedUser(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).intentsOfAuthenticatedUser(options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        patchIntent(id, patchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).patchIntent(id, patchRequest, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        reactivateIntent(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).reactivateIntent(id, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        searchByCaseId(caseId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).searchByCaseId(caseId, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        switchIntentStatus(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).switchIntentStatus(id, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        terminateIntent(id, intentTerminationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).terminateIntent(id, intentTerminationRequest, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        validate(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield IntentApiAxiosParamCreator(configuration).validate(id, options);
                return (axios = globalAxios, basePath = BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
    };
};
export const IntentApiFactory = function (configuration, basePath, axios) {
    return {
        copyIntent(intentCopyRequest, options) {
            return IntentApiFp(configuration).copyIntent(intentCopyRequest, options).then((request) => request(axios, basePath));
        },
        createIntent(intentCreationRequest, options) {
            return IntentApiFp(configuration).createIntent(intentCreationRequest, options).then((request) => request(axios, basePath));
        },
        exportIntents(createdAfter, createdUntil, updatedAfter, updatedUntil, status, embed, limit, cursorBefore, cursorAfter, options) {
            return IntentApiFp(configuration).exportIntents(createdAfter, createdUntil, updatedAfter, updatedUntil, status, embed, limit, cursorBefore, cursorAfter, options).then((request) => request(axios, basePath));
        },
        filterForIntents(filterRequest, options) {
            return IntentApiFp(configuration).filterForIntents(filterRequest, options).then((request) => request(axios, basePath));
        },
        getEstate(id, estateId, options) {
            return IntentApiFp(configuration).getEstate(id, estateId, options).then((request) => request(axios, basePath));
        },
        getIntent(id, options) {
            return IntentApiFp(configuration).getIntent(id, options).then((request) => request(axios, basePath));
        },
        getIntentInfo(id, options) {
            return IntentApiFp(configuration).getIntentInfo(id, options).then((request) => request(axios, basePath));
        },
        getIntentInfoByCaseId(caseId, options) {
            return IntentApiFp(configuration).getIntentInfoByCaseId(caseId, options).then((request) => request(axios, basePath));
        },
        getIntentPermission(id, action, options) {
            return IntentApiFp(configuration).getIntentPermission(id, action, options).then((request) => request(axios, basePath));
        },
        getIntentProcess(id, options) {
            return IntentApiFp(configuration).getIntentProcess(id, options).then((request) => request(axios, basePath));
        },
        intentsOfAuthenticatedCustomer(limit, cursorBefore, cursorAfter, options) {
            return IntentApiFp(configuration).intentsOfAuthenticatedCustomer(limit, cursorBefore, cursorAfter, options).then((request) => request(axios, basePath));
        },
        intentsOfAuthenticatedUser(options) {
            return IntentApiFp(configuration).intentsOfAuthenticatedUser(options).then((request) => request(axios, basePath));
        },
        patchIntent(id, patchRequest, options) {
            return IntentApiFp(configuration).patchIntent(id, patchRequest, options).then((request) => request(axios, basePath));
        },
        reactivateIntent(id, options) {
            return IntentApiFp(configuration).reactivateIntent(id, options).then((request) => request(axios, basePath));
        },
        searchByCaseId(caseId, options) {
            return IntentApiFp(configuration).searchByCaseId(caseId, options).then((request) => request(axios, basePath));
        },
        switchIntentStatus(id, options) {
            return IntentApiFp(configuration).switchIntentStatus(id, options).then((request) => request(axios, basePath));
        },
        terminateIntent(id, intentTerminationRequest, options) {
            return IntentApiFp(configuration).terminateIntent(id, intentTerminationRequest, options).then((request) => request(axios, basePath));
        },
        validate(id, options) {
            return IntentApiFp(configuration).validate(id, options).then((request) => request(axios, basePath));
        },
    };
};
export class IntentApi extends BaseAPI {
    copyIntent(intentCopyRequest, options) {
        return IntentApiFp(this.configuration).copyIntent(intentCopyRequest, options).then((request) => request(this.axios, this.basePath));
    }
    createIntent(intentCreationRequest, options) {
        return IntentApiFp(this.configuration).createIntent(intentCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    exportIntents(createdAfter, createdUntil, updatedAfter, updatedUntil, status, embed, limit, cursorBefore, cursorAfter, options) {
        return IntentApiFp(this.configuration).exportIntents(createdAfter, createdUntil, updatedAfter, updatedUntil, status, embed, limit, cursorBefore, cursorAfter, options).then((request) => request(this.axios, this.basePath));
    }
    filterForIntents(filterRequest, options) {
        return IntentApiFp(this.configuration).filterForIntents(filterRequest, options).then((request) => request(this.axios, this.basePath));
    }
    getEstate(id, estateId, options) {
        return IntentApiFp(this.configuration).getEstate(id, estateId, options).then((request) => request(this.axios, this.basePath));
    }
    getIntent(id, options) {
        return IntentApiFp(this.configuration).getIntent(id, options).then((request) => request(this.axios, this.basePath));
    }
    getIntentInfo(id, options) {
        return IntentApiFp(this.configuration).getIntentInfo(id, options).then((request) => request(this.axios, this.basePath));
    }
    getIntentInfoByCaseId(caseId, options) {
        return IntentApiFp(this.configuration).getIntentInfoByCaseId(caseId, options).then((request) => request(this.axios, this.basePath));
    }
    getIntentPermission(id, action, options) {
        return IntentApiFp(this.configuration).getIntentPermission(id, action, options).then((request) => request(this.axios, this.basePath));
    }
    getIntentProcess(id, options) {
        return IntentApiFp(this.configuration).getIntentProcess(id, options).then((request) => request(this.axios, this.basePath));
    }
    intentsOfAuthenticatedCustomer(limit, cursorBefore, cursorAfter, options) {
        return IntentApiFp(this.configuration).intentsOfAuthenticatedCustomer(limit, cursorBefore, cursorAfter, options).then((request) => request(this.axios, this.basePath));
    }
    intentsOfAuthenticatedUser(options) {
        return IntentApiFp(this.configuration).intentsOfAuthenticatedUser(options).then((request) => request(this.axios, this.basePath));
    }
    patchIntent(id, patchRequest, options) {
        return IntentApiFp(this.configuration).patchIntent(id, patchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    reactivateIntent(id, options) {
        return IntentApiFp(this.configuration).reactivateIntent(id, options).then((request) => request(this.axios, this.basePath));
    }
    searchByCaseId(caseId, options) {
        return IntentApiFp(this.configuration).searchByCaseId(caseId, options).then((request) => request(this.axios, this.basePath));
    }
    switchIntentStatus(id, options) {
        return IntentApiFp(this.configuration).switchIntentStatus(id, options).then((request) => request(this.axios, this.basePath));
    }
    terminateIntent(id, intentTerminationRequest, options) {
        return IntentApiFp(this.configuration).terminateIntent(id, intentTerminationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    validate(id, options) {
        return IntentApiFp(this.configuration).validate(id, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map